export default {
    "Project-Id-Version": "",
    "POT-Creation-Date": "2026-02-25T21:26:27.749Z",
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Edito",
    "PO-Revision-Date": "2026-02-25T21:26:27.952Z",
    "Language": "pl-PL",
    "Messages": {
        "1": "",
        "2": "",
        "3": "",
        "4": "",
        " - klient http z następującymi metodami:": "",
        " - powoduje wywołanie akcji jako użytkownik systemowy": "",
        " - pozwala na wyciąganie wszystkich serwisów": "",
        " - tablica ze wszystkimi akcjami procesu": "",
        " - tablica ze wszystkimi akcjami procesu (tylko dla skryptów timerowych)": "",
        " - ustawia ciało zapytania jako przekazany obiekt": "",
        " - ustawia endpointa na określony url z wybraną metodą HTTP": "",
        " - wysyła zapytanie i zwraca odpowiedź": "",
        " - zawiera dane dokumentu sprzed zapisu formularza w takim samym formacie jak document": "",
        " - zawiera pole BaseUrl z nazwą licencji w postaci, w jakiej trafia do url": "",
        " - zawiera pole PublicId oraz DbData, które jest słownikiem zawierającym wszystkie indeksowane pola dokumentu": "",
        " - zawiera pole PublicId oraz DbDataDynamic, które jest słownikiem zawierającym wszystkie indeksowane pola dokumentu": "",
        " - zawiera pole value z id aktualnego procesu": "",
        "...": "",
        "' + file.filename + '": "",
        "' + func.name + '": "",
        "“Po potwierdzeniu wybrani użytkownicy całkowicie utracą dostęp do dokumentu. Czy chcesz kontynuować?": "",
        "(Przekroczyłeś limit aktywnych kont użytkowników, skontaktuj się z dostawcą systemu w celu zmiany warunków licencji)": "",
        "%0": "",
        "%0 wyniki": "",
        "%0 wyników": "",
        "%0 z %1": "",
        "%0 znaków": "",
        "+3 dni": "",
        "<Brak nazwy>": "",
        "${copied ? 'Skopiowano' : 'Kopiuj'}": "",
        "${el.text}": "",
        "${form.variants > 1 ? 'Generuj obrazy' : 'Generuj obraz'}": "",
        "${getCurrentScope().label}": "",
        "${item.entityName}": "",
        "${item.text}": "",
        "${item.value}": "",
        "${loading ? 'Ładowanie elementów...' : 'Nie znaleziono żadnych elementów.'}": "",
        "${props.inputPlaceholder}": "",
        "${str}": "",
        "${text}": "",
        "${tokenVisibility ? 'Ukryj' : 'Pokaż'} token": "",
        "1 godzina": "",
        "1 wynik": "",
        "1:1": "",
        "10 minut": "",
        "12 godzin": "",
        "15 minut": "",
        "2 dni": "",
        "2 miesiące": "",
        "2 tygodnie": "",
        "24 godziny": "",
        "3 dni": "",
        "3 godziny": "",
        "3 miesiące": "",
        "30 minut": "",
        "4 dni": "",
        "4:7": "",
        "5 dni": "",
        "5 minut": "",
        "6 dni": "",
        "6 godzin": "",
        "7:4": "",
        "Aby dodawać członków zespołu musisz najpierw zapisać formularz.": "",
        "Aby dodawać linie do szablonu musisz najpierw zapisać formularz.": "",
        "Aby edytować tylko bieżącą wersję roboczą utwórz nową wersję procesu": "",
        "Aby móc przetestować poprawność kluczy, najpierw zapisz formularz.": "",
        "Aby podpisać dokument zaloguj się do usługi mSzafir klikając przycisk poniżej.": "",
        "Aby podpisać dokument zaloguj się do usługi SimplySign klikając przycisk poniżej.": "",
        "Aby sprawdzić strukturę danych, które powinny zostać przekazane do importu, pobierz przykładowy plik przyciskiem \"Pobierz szablon\"": "",
        "Aby system przyjął zapytanie akcji systemowej, należy wysłać klucz systemowy w nagłówku Authorization": "",
        "Aby system przyjął zapytanie do webhooka, należy wysłać klucz systemowy w nagłówku Authorization": "",
        "Aby uzyskać klucz systemowy, skontaktuj się z administratorem systemu.": "",
        "Aby zawężyć wybór terminów dostępnych na liście możesz wyfiltrować wpisy na podstawie pól formularza zdefiniowanych w definicji słownika.": "",
        "Aby zobaczyć aktualny podgląd szablonu musisz go zapisać": "",
        "Adaptive sampling": "",
        "Administracja": "",
        "Administracja - Kraje": "",
        "Administracja - Role": "",
        "Administracja - Stanowiska pracy": "",
        "Administracja - Użytkownicy": "",
        "Administracja - Zespoły": "",
        "Administratorzy": "",
        "Adres": "",
        "Adres do eDoręczeń: ": "",
        "Adres domenowy": "",
        "Adres e-mail": "",
        "Adres e-mail potwierdzony": "",
        "Adres email": "",
        "Adres email nadawcy": "",
        "Adres IP": "",
        "Adres IP: %0": "",
        "Adres korespądencyjny: ": "",
        "Adres serwera": "",
        "Adres siedziby: ": "",
        "Adres URL": "",
        "Akcent": "",
        "Akceptacja": "",
        "Akceptacja dokumentów": "",
        "Akceptacja dokumentu": "",
        "Akceptacja własnych dokumentów": "",
        "Akceptacja wszystkich dokumentów": "",
        "Akceptant do zastąpienia": "",
        "Akceptowany format danych": "",
        "Akceptuj": "",
        "Akcja": "",
        "Akcja systemowa": "",
        "Akcja wykonana pomyślnie": "",
        "Akcje": "",
        "Akcje administracyjne": "",
        "Akcje zostały zapisane": "",
        "Aktualizacja: {0}": "",
        "Aktualizuj": "",
        "Aktualna sesja": "",
        "Aktualne hasło": "",
        "Aktualne urządzenie": "",
        "Aktywna": "",
        "Aktywna do": "",
        "Aktywne": "",
        "Aktywne kanały komunikacji": "",
        "Aktywne sesje": "",
        "Aktywne źródła": "",
        "Aktywni": "",
        "Aktywność": "",
        "Aktywny": "",
        "Aktywny filtr:": "",
        "Aktywnych kont": "",
        "Aktywuj OCR": "",
        "Aktywuj tłumaczenia": "",
        "Aktywuj zestaw inteligentnych narzędzi": "",
        "Alert": "",
        "Alias": "",
        "Alias może zawierać tylko znaki alfanumeryczne oraz znak podkreślenia": "",
        "Alias został przepięty.": "",
        "Analizuję typ i kategorię dokumentu...": "",
        "aneks": "",
        "Angielski": "",
        "Ankieta": "",
        "Anonimizacja kontrahenta rozpoczęta. W zależności od ilości dokumentów proces ten może potrwać do kilkunastu minut.": "",
        "Anonimizuj": "",
        "Anonimizuj dane osobowe": "",
        "Anonimowy": "",
        "Anuluj": "",
        "Aplikacja": "",
        "Aplikacja zostanie zrestartowana w przeciągu maksymalnie 60 sekund.": "",
        "App ID": "",
        "App Secret": "",
        "application/json": "",
        "application/x-www-form-urlencoded": "",
        "Archiwizuj przez maksymalnie (dni)": "",
        "Argument": "",
        "Asystent": "",
        "Asystent AI": "",
        "Asystent został dodany.": "",
        "Asystent został zaktualizowany.": "",
        "Asystenta AI": "",
        "Autentykacja SimplySign": "",
        "Automatyzacja": "",
        "Autor": "",
        "Autor dokumentu": "",
        "Azure AI": "",
        "Azure AI Vision": "",
        "Azure Application Insights": "",
        "Azure OpenAI": "",
        "Basic Auth": "",
        "Baza danych": "",
        "Baza danych tego klienta jest nieaktualna.": "",
        "Bazy danych": "",
        "Bez formularza": "",
        "Bezpieczeństwo": "",
        "Bezpieczne połączenie SSL": "",
        "Bezpośrednio do członków wybranej grupy (np. działu)": "",
        "Bierz pod uwagę dokumenty powiązane po polu:": "",
        "Bieżący dokument": "",
        "Biuro": "",
        "Blokada konta": "",
        "Blokowanie kont": "",
        "Blokuj akcje na wybranym dokumencie podczas wykonania akcji grupowych": "",
        "Blokująca": "",
        "Błąd": "",
        "Błąd 404. Nie znaleziono żądanego zasobu.": "",
        "Błąd podczas eksportowania": "",
        "Błąd podczas generowania dokumentu": "",
        "Błąd podczas oznaczania jako nieodczytany": "",
        "Błąd podczas pobierania": "",
        "Błąd podczas pobierania danych": "",
        "Błąd podczas pobierania listy": "",
        "Błąd podczas pobierania schematu": "",
        "Błąd podczas pobierania szczegółów": "",
        "Błąd podczas pobierania udostępnionych dokumentów": "",
        "Błąd podczas pobierania użytkownika": "",
        "Błąd podczas renderowania PDF": "",
        "Błąd podczas rezerwacji": "",
        "Błąd podczas wykonywania akcji": "",
        "Błąd podczas zatrzymywania udostępniania": "",
        "Błąd walidacji": "",
        "Błędne": "",
        "Błędny": "",
        "Błędy": "",
        "Błędy podczas wykonywania akcji": "",
        "Błędy walidacji należy przypisać do \"entry.errors.value\" w postaci tablicy komunikatów.": "",
        "Brak": "",
        "Brak akcji": "",
        "Brak aktualności do wyświetlenia": "",
        "Brak aktywnego filtru": "",
        "Brak błędów do wyświetlenia": "",
        "Brak cennika dla wybranego dostawcy.": "",
        "Brak danych": "",
        "Brak danych dla wykresu": "",
        "Brak danych do wyświetlenia": "",
        "Brak danych do wyświetlenia wykresu": "",
        "Brak dodanych kolumn": "",
        "Brak dostępnych akcji": "",
        "Brak działu nadrzędnego": "",
        "Brak elementów": "",
        "Brak informacji o pochodzeniu uprawnienia": "",
        "Brak kluczy": "",
        "Brak kolekcji": "",
        "Brak kolumn": "",
        "Brak kolumn numerycznych": "",
        "Brak limitu": "",
        "Brak logów do wyświetlenia": "",
        "Brak nazwy": "",
        "Brak nowych powiadomień.": "",
        "Brak odpowiedzi": "",
        "Brak opcji": "",
        "Brak pracowników w danym dziale": "",
        "Brak przesyłki": "",
        "Brak wartości wyświetlanej": "",
        "Brak wersji": "",
        "Brak wpisów": "",
        "Brak wyboru": "",
        "Brak wymaganych danych": "",
        "Brak wyników": "",
        "Brak wyników wyszukiwania": "",
        "Brak wyników!": "",
        "Brak załączników": "",
        "Brak zdefiniowanych ról.": "",
        "Brak zdefiniowanych zespołów.": "",
        "Bramka SMS": "",
        "Budżet": "",
        "Cache będzie przechowywany z wykorzystaniem serwera Redis.": "",
        "Cache po stronie serwera": "",
        "Cache-Control": "",
        "Całkowita ilość do importu:": "",
        "Cel aktywny": "",
        "Cel został dodany.": "",
        "cel został usunięty.": "",
        "Cel został zaktualizowany.": "",
        "Cele": "",
        "Cena": "",
        "Cena w dolarach sumy tokenów wejściowych i wyjściowych.": "",
        "Cennik Azure OpenAI": "",
        "Cennik AzureAI": "",
        "Cennik OpenAI": "",
        "Centrum powiadomień": "",
        "Checkbox": "",
        "Ciemny": "",
        "Client ID": "",
        "Client Secret": "",
        "co": "",
        "Co 10 dni": "",
        "Co 10 minut": "",
        "Co 12 godzin": "",
        "Co 15 minut": "",
        "Co 2 godziny": "",
        "Co 2 minuty": "",
        "Co 2 tygodnie": "",
        "Co 20 minut": "",
        "Co 3 godziny": "",
        "co 3 miesiące": "",
        "Co 3 miesiące": "",
        "co 30 dni": "",
        "Co 30 minut": "",
        "Co 4 miesiące": "",
        "Co 5 dni": "",
        "Co 5 minut": "",
        "Co 6 godzin": "",
        "co 6 miesięcy": "",
        "Co chcesz wygenerować?": "",
        "Co drugi dzień": "",
        "Co drugi miesiąc": "",
        "Co godzinę": "",
        "Co miesiąc": "",
        "Co minutę": "",
        "Co pół roku": "",
        "co rok": "",
        "Co tydzień": "",
        "Codziennie": "",
        "Cofnięto prywatność dokumentu": "",
        "Cofnij ostatnią operację": "",
        "Connection String": "",
        "Coś poszło nie tak": "",
        "Cron": "",
        "Cyfry": "",
        "Czas": "",
        "Czas dodania": "",
        "Czas pomiędzy": "",
        "Czas rozpoczęcia": "",
        "Czas trwania (minuty)": "",
        "Czas trwania blokady": "",
        "Czas uruchomienia": "",
        "Czas zakończenia": "",
        "Czat z asystentem": "",
        "Czerwiec": "",
        "Częstotliwość wykonywania (Cron)": "",
        "Członkowie zespołu": "",
        "Cztery kolumny": "",
        "Czwartek": "",
        "Czy aby na pewno chesz przywrócić ustawienia domyślne?": "",
        "Czy aby na pewno chesz zrestartować aplikacje?": "",
        "Czy chcesz ograniczyć dostęp do dokumentu w zastępstwie?": "",
        "Czy chcesz usunąć ograniczenie dostępu do dokumentu w zastępstwie?": "",
        "Czy na pewno chcesz dezaktywować spółkę?": "",
        "Czy na pewno chcesz rozgrupować te pola?": "",
        "Czy na pewno chcesz usunąć filtr": "",
        "Czy na pewno chcesz usunąć szablon?": "",
        "Czy na pewno chcesz usunąć tego kontrahenta?": "",
        "Czy na pewno chcesz usunąć ten dokument?": "",
        "Czy na pewno chcesz usunąć ten obiekt?": "",
        "Czy na pewno chcesz usunąć ten rekord?": "",
        "Czy na pewno chcesz usunąć ten widget?": "",
        "Czy na pewno chcesz usunąć to pole wspólne?": "",
        "Czy na pewno chcesz usunąć widget?": "",
        "Czy na pewno chcesz zanonimizować dane osobowe tego kontrahenta?": "",
        "Czy na pewno chcesz zmienić moduł, wszystkie dane formularza zostaną utracone.": "",
        "Czy napewno chcesz usunąć tą zmienną środowiskową?": "",
        "Czy napewno chcesz usunąć ten szablon": "",
        "Czynności": "",
        "czynność": "",
        "Czynność": "",
        "Czynność zostanie wpisana w historii po wznowieniu obiegu": "",
        "Dalej": "",
        "DALL-E 3": "",
        "Dane": "",
        "Dane do zapisania": "",
        "Dane formularza są przechowywane w obiekcie Entry.": "",
        "Dane osobowe": "",
        "Dane podstawowe": "",
        "Dane tabeli przechowywane są w obiekcie table": "",
        "Dane w tabeli": "",
        "Dane wejściowe": "",
        "Dane wektorowe": "",
        "Dane wyjściowe": "",
        "Dane z tego pola są przechowywane w bazie w szyfrowanej formie": "",
        "Dane, które zwraca skrypt są dopisywane do właściwości dostępnych w zmiennej <b>@Model</b> w szablonie. Z tego względu skrypt musi zwracać słownik typu <b>Dictionary&amp;lt;string, object&amp;gt;</b>": "",
        "danger": "",
        "dark": "",
        "Darmowe środowisko OpenJDK można pobrać i zainstalować ze strony": "",
        "Data": "",
        "Data aktywacji": "",
        "Data anonimizacji": "",
        "Data dezaktywacji": "",
        "Data do": "",
        "Data dodania": "",
        "Data dokumentu": "",
        "Data i czas": "",
        "Data końcowa": "",
        "Data Kursu": "",
        "Data modyfikacji": "",
        "Data od": "",
        "Data opuszczenia zespołu": "",
        "Data otrzymania": "",
        "Data powiadomienia": "",
        "Data rejestracji": "",
        "Data rozpoczęcia": "",
        "Data udostępnienia": "",
        "Data uruchomienia": "",
        "Data uruchomienia (UTC)": "",
        "Data usunięcia": "",
        "Data utworzenia": "",
        "Data utworzenia wersji": "",
        "Data utworzenia: ": "",
        "Data użycia": "",
        "Data wygaśnięcia": "",
        "Data wykonania": "",
        "Data wylogowania": "",
        "Data wysyłki": "",
        "Data wywołania": "",
        "Data zakończenia": "",
        "Data zakończenia blokady konta": "",
        "Data zalogowania": "",
        "Data zapoznania": "",
        "Data zapytania": "",
        "Data zatrudnienia": "",
        "Data zatrzymania udostępniania": "",
        "Data zdarzenia": "",
        "Data zwolnienia": "",
        "Data: %0 | Status: %1": "",
        "Debug": "",
        "DEBUG OFF": "",
        "DEBUG ON": "",
        "Debugger": "",
        "Dedykowane": "",
        "DeepL": "",
        "Definicja": "",
        "Definicja (JSON)": "",
        "Definicja formularza znajduje się w obiekcie Form.": "",
        "Definicja pól JSON": "",
        "Definicję pól zapisujemy jako obiekt JSON, którego klucze to klucze pól formularza, a wartości to obiekty z właściwościami konfigurującymi dane pole.": "",
        "DELETE: Usunięcie wpisu": "",
        "Design Studio": "",
        "Devexpress": "",
        "Dezaktywacja spółki spowoduje trwałe usunięcie powiązania z pracownikami. ": "",
        "Dezaktywuj": "",
        "Diagram": "",
        "Dla kogo": "",
        "Dla takiej konfiguracji musimy zwrócić obiekt <b>List&amp;lt;Dictionary&amp;lt;string, object&amp;gt;&amp;gt;</b> dzięki czemu nadpiszemy cały obiekt <b>@Model</b> i skrypt wykona się tylko raz": "",
        "Dla uzyskania najlepszego wyniku w to pole wstaw tylko i wyłącznie informacje co wybieramy, np \"Rodzaj dokumentu\" - dostępne opcje kontrolki są dostarczane Asystentowi automatycznie przez system": "",
        "Dla uzyskania najlepszego wyniku w to pole wstaw tylko i wyłącznie informacje czym jest słownik, np \"Forma płatności\" - opcje dostępne w słowniku są dostarczane automatycznie wraz z wartością domyślną Asystentowi przez system": "",
        "Dla uzyskania najlepszego wyniku w to pole wstaw tylko i wyłącznie kim jest kontrahent na dokumencie np. \"Wystawca faktury\" lub \"Nadawca\"": "",
        "Dla wybranych dokumentów nie znaleziono wspólnych akcji do wykonania": "",
        "Długość czasu przechowywania": "",
        "Długość trwania sesji [min": "",
        "dni": "",
        "Dni": "",
        "Dni wolne": "",
        "Dni wolne zostały zaimportowane.": "",
        "do": "",
        "Do": "",
        "Do akceptacji": "",
        "do czasu ręcznego odblokowania": "",
        "Do działu": "",
        "Do grupy użytkowników": "",
        "Do kierowników działu autora dokumentu": "",
        "Do opiekuna powiązanej umowy": "",
        "Do osoby wykonującej akcję oraz do osoby wybranej na formularzu": "",
        "Do osoby wykonującej bieżącą akcję": "",
        "Do pola tytuł można wprowadzić pola dokumentu jak do treści": "",
        "Do przełożonego użytkownika wykonującego wskazany krok": "",
        "Do rezygnacji": "",
        "Do użytkownika": "",
        "Do użytkownika wykonującego wskazany krok": "",
        "Do użytkownika z najmniejszą ilością zadań w grupie (np. zespole)": "",
        "Do użytkownika z pola dokumentu": "",
        "Do użytkownika/grupy użytkowników wskazanej w polach dokumentu": "",
        "Do użytkownika/grupy użytkowników wskazanej w wybranym kroku na wskazanym formularzu": "",
        "Do użytkownika/grupy użytkowników/kontrahenta/maila wskazanego w polach dokumentu": "",
        "Do użytkowników wykonujących obecny krok z wyjątkiem osoby wykonującej akcję": "",
        "Do użytkowników z wybranego działu": "",
        "Do wprowadzenia": "",
        "do wszystkich zaproszonych": "",
        "Do wybranego użytkownika": "",
        "Do wybranego użytkownika i działu": "",
        "Do zespołu": "",
        "Do zespołu/działu wybranego w polu dokumentu": "",
        "doc['Nazwa pola'": "",
        "Docs": "",
        "Dodaj": "",
        "Dodaj / Edytuj": "",
        "Dodaj akceptantów": "",
        "Dodaj akcję": "",
        "Dodaj asystenta": "",
        "Dodaj automatyzacje": "",
        "Dodaj cel": "",
        "Dodaj czynność": "",
        "Dodaj danę wektorową": "",
        "Dodaj dni": "",
        "Dodaj do ulubionych": "",
        "Dodaj do zespołu": "",
        "Dodaj dokument": "",
        "Dodaj dział": "",
        "Dodaj endpoint": "",
        "Dodaj formularz": "",
        "Dodaj funkcję": "",
        "Dodaj grupę": "",
        "Dodaj jeden lub więcej widgetów, aby uzyskać wgląd w postępy swojego zespołu.": "",
        "Dodaj kategorię": "",
        "Dodaj klienta": "",
        "Dodaj komentarz": "",
        "Dodaj komponent": "",
        "Dodaj kontrahenta": "",
        "Dodaj licznik": "",
        "Dodaj logo": "",
        "Dodaj moduł": "",
        "Dodaj nową linię": "",
        "Dodaj nowego kontrahenta": "",
        "Dodaj nowy folder": "",
        "Dodaj nowy wątek": "",
        "Dodaj plik": "",
        "Dodaj plik dokumentu, a Asystent AI automatycznie go skategoryzuje i wprowadzi.": "",
        "Dodaj pliki": "",
        "Dodaj pliki asystenta": "",
        "Dodaj podsumowanie": "",
        "Dodaj pole": "",
        "Dodaj powiadomienie weryfikacyjne": "",
        "Dodaj pozycję": "",
        "Dodaj przycisk z przekierowaniem do dokumentu": "",
        "Dodaj regułe": "",
        "Dodaj rolę": "",
        "Dodaj scenariusz": "",
        "Dodaj sekcję": "",
        "Dodaj serwer": "",
        "Dodaj shortcode": "",
        "Dodaj skan": "",
        "Dodaj słownik": "",
        "Dodaj słowo": "",
        "Dodaj status": "",
        "Dodaj stronę": "",
        "Dodaj synonimy": "",
        "Dodaj szablon": "",
        "Dodaj tabelę wektorową": "",
        "Dodaj termin": "",
        "Dodaj token": "",
        "Dodaj użytkownika": "",
        "Dodaj webhooka": "",
        "Dodaj wersję": "",
        "Dodaj widget": "",
        "Dodaj wiersz": "",
        "Dodaj wpis": "",
        "Dodaj z AI": "",
        "Dodaj załączniki": "",
        "Dodaj zastępstwo": "",
        "Dodaj zespół": "",
        "Dodaj źródło": "",
        "Dodaj źródło danych": "",
        "Dodają kierownicy wybranego działu": "",
        "Dodaje  każda osoba która ma uprawnienie (widzi moduł)": "",
        "Dodaje członek grupy użytkowników": "",
        "Dodaje członek zespołu": "",
        "Dodaje wybrany użytkownik": "",
        "dodał": "",
        "dodane i edytowane przeze mnie": "",
        "Dodanie": "",
        "Dodanie celu": "",
        "Dodanie dokumentu": "",
        "Dodanie działu": "",
        "Dodanie endpointu": "",
        "Dodanie formularza": "",
        "Dodanie klienta": "",
        "Dodanie komponentu": "",
        "Dodanie modułu": "",
        "Dodanie roli": "",
        "Dodanie scenariusza": "",
        "Dodanie serwera": "",
        "Dodanie skryptu": "",
        "Dodanie spółki": "",
        "Dodanie szablonu": "",
        "Dodanie użytkownika": "",
        "Dodanie webhooka": "",
        "Dodanie wpisu": "",
        "Dodanie zastępstwa": "",
        "Dodanie zespołu": "",
        "Dodanie źródła": "",
        "Dodanie źródła danych": "",
        "Dodano do ulubionych": "",
        "Dodano nową wersję": "",
        "dodany": "",
        "Dodanych plików %0 (limit wynosi %1).": "",
        "Dodatkowa weryfikacja": "",
        "Dodatkowe informacje": "",
        "Dodatkowe opcje": "",
        "Dodatkowe pola do zgrupowania": "",
        "Dodatkowe pole tekstowe z dokumentu powiązanego": "",
        "Dodatkowo dostępny jest obiekt document zawierający dane dokumentu oraz obiekt data z polami ProcessId, ModuleId i ModuleVersionId.": "",
        "Dodatkowo po uzupełnieniu właściwości options można usatwić właściwość 'multiple', aby w polu można było wskazać wiele opcji": "",
        "Dodatkowo skrypt zwraca kontrolki dla nowego formularza, dlatego wymagane jest, aby zwracał obiekt typu:": "",
        "Dodawanie": "",
        "Dodawanie dokumentów": "",
        "Dodawanie i edycja własnych dokumentów": "",
        "Dodawanie modułu": "",
        "Dodawanie wartości dwóch kolumn": "",
        "Dokument": "",
        "Dokument %0": "",
        "Dokument jest niepoprawnie opisany": "",
        "Dokument już jest udostępniony": "",
        "Dokument PDF": "",
        "Dokument powiązany": "",
        "Dokument tekstowy": "",
        "Dokument z pola": "",
        "Dokument został pobrany": "",
        "Dokument został podpisany": "",
        "Dokument został pomyślnie przetworzony przez AI.": "",
        "Dokument został powiązany.": "",
        "Dokument został udostępniony dla wybranych użytkowników.": "",
        "Dokument został usunięty.": "",
        "Dokument został wyeksportowany": "",
        "Dokument.Obecny target.Operator.-.System.Osoba wykonująca akcję": "",
        "Dokument.Pola dokumentu powiązanego.Dokument.Dokumenty powiązane.Umowa.Opiekun": "",
        "Dokument.Pola dokumentu powiązanego.Dokument.Dokumenty powiązane.Zamówienie.Kwota.Operator.>.Process.Zmienne (liczby).1000": "",
        "Dokument.Pola dokumentu.{Nazwa pola}": "",
        "Dokument.Pola dokumentu.{Nazwa pola}.Operator.ma wartość": "",
        "Dokument.Pola dokumentu.{Pole grupa użytkowników}": "",
        "Dokument.Pola dokumentu.{Pole z użytkownikiem}": "",
        "Dokument.Pola dokumentu.Autor.System.Dział użytkownika.System.Kierownicy działu.": "",
        "Dokumentacja": "",
        "dokumentów przetworzonych": "",
        "Dokumenty": "",
        "Dokumenty kontrahenta": "",
        "Dokumenty powiązane": "",
        "Dokumenty przekazane do wglądu na zasadzie powyższej nie będą dostępne z poziomu Zestawienia dokumentów i wyszukiwarki globalnej, a jedynie dostępne przez szczegóły dokumentu głównego.": "",
        "Dołącz stack trace": "",
        "Domena": "",
        "Domyślna": "",
        "Domyślna skala czasu": "",
        "Domyślna wartość": "",
        "Domyślne": "",
        "Domyślne filtry": "",
        "Domyślnie skrypt jest wykonywany na każdym dokumencie": "",
        "Domyślnie ukryte": "",
        "Domyślnie widoczne": "",
        "Domyślny": "",
        "Domyślny pager": "",
        "Domyślny zakres": "",
        "Dopasowano do modułu:": "",
        "Dopasowuję do modułu": "",
        "Dopuść brak odpowiedzi": "",
        "Dostawca": "",
        "Dostawca podpisu": "",
        "Dostęp do modułu": "",
        "Dostęp do systemu": "",
        "Dostęp do zmiennych terminu słownika (np. stawka VAT)": "",
        "Dostęp niezdefiniowany": "",
        "Dostęp przyznany": "",
        "Dostęp zabroniony": "",
        "Dostępna jest nowa aktualizacja. Proszę zapisać postęp pracy i klinąć przycisk \"Aktualizuj\". Możesz również zaakceptować aktualizację poprzez odświeżenie okna przeglądarki. Brak aktualizacji może spowodować błędy.": "",
        "Dostępne": "",
        "Dostępne operatory": "",
        "Dostępne są propki Form i Entry zawierające odpowiednio strukturę formularza oraz dane z wypełnionego formularza": "",
        "Dostępne skróty klawiszowe": "",
        "Dostępność": "",
        "Dostępny dla modułu": "",
        "Dostępny limit": "",
        "Dostosuj wysokość do wysokości zawartości": "",
        "Dotyczy tylko dokumentów z modułów do których użytkownik ma dostęp": "",
        "Dotyczy wznawiania obiegu": "",
        "dowolnej wybranej wersji": "",
        "Dowolny": "",
        "Dozwolone rozszerzenia": "",
        "Dozwolone rozszerzenia: %0.": "",
        "Dozwolone są tylko małe i duże litery": "",
        "Dozwolone są tylko małe litery i znak -": "",
        "Dozwolone typy plików: %0.": "",
        "Drugie imię": "",
        "Drugorzędny": "",
        "Dsn": "",
        "Duplikuj": "",
        "Duża": "",
        "Duży": "",
        "Duży układ siatki": "",
        "Dwie kolumny": "",
        "Dynamicznie": "",
        "Dynamiczny modal": "",
        "Dyrektor": "",
        "Dyrektorzy": "",
        "Dyrektywa max-age=N wskazuje, że odpowiedź pozostaje świeża do N sekund po wygenerowaniu odpowiedzi.": "",
        "Dyrektywa no-store wskazuje, że jakikolwiek cache dowolnego rodzaju nie powinien przechowywać tej odpowiedzi.": "",
        "Dyrektywa PRIVATE wskazuje, że odpowiedź może być przechowywana wyłącznie w prywatnej pamięci podręcznej (np. lokalnej pamięci przeglądarki).": "",
        "Dyrektywa PUBLIC wskazuje, że odpowiedź może być przechowywana we współdzielonej pamięci podręcznej (np. proxy).": "",
        "Dyrektywa s-maxage jest ignorowana przez prywatne pamięci podręczne i zastępuje wartość określoną przez dyrektywę max-age dla współdzielonych pamięci podręcznych.": "",
        "Dyrektywa s-maxage wskazuje, jak długo odpowiedź pozostaje aktualna we współdzielonej pamięci podręcznej (np. proxy).": "",
        "Dyrektywy zakresu": "",
        "Dział": "",
        "Dział aktywny": "",
        "Dział nadrzędny": "",
        "Dział został dodany.": "",
        "Dział został zaktualizowany.": "",
        "Działania masowe": "",
        "Działy": "",
        "Dzielenie": "",
        "Dziennik korespondencji": "",
        "Dzienny": "",
        "dzień": "",
        "Dzień": "",
        "dzień (dni)": "",
        "Dzień miesiąca": "",
        "Dzień wolny został dodany.": "",
        "Dzień wolny został zaktualizowany.": "",
        "Dziękujemy za wypełnienie formularza": "",
        "Dziś minus": "",
        "Dziś plus": "",
        "E-Doręczenia Ade": "",
        "E-mail": "",
        "Edycja": "",
        "Edycja celu": "",
        "Edycja dokumentów": "",
        "Edycja dokumentu": "",
        "Edycja działu": "",
        "Edycja elementu": "",
        "Edycja endpointu": "",
        "Edycja formularza": "",
        "Edycja klienta": "",
        "Edycja komponentu": "",
        "Edycja modułu": "",
        "Edycja pól dokumentu": "",
        "Edycja roli": "",
        "Edycja scenariusza": "",
        "Edycja serwera": "",
        "Edycja skryptu": "",
        "Edycja słownika": "",
        "Edycja szablonu": "",
        "Edycja terminu": "",
        "Edycja użytkownika": "",
        "Edycja w popupie": "",
        "Edycja webhooka": "",
        "Edycja wpisu": "",
        "Edycja wszystkich dokumentów": "",
        "Edycja zastępstwa": "",
        "Edycja zespołu": "",
        "Edycja źródła": "",
        "Edycja źródła danych": "",
        "Edytor": "",
        "Edytowana wersja": "",
        "Edytowane mogą być tylko szablony włączonych i obsługiwanych kanałów.": "",
        "Edytuj": "",
        "Edytuj akcję": "",
        "Edytuj członka grupy": "",
        "Edytuj danę wektorową": "",
        "Edytuj dashboard": "",
        "Edytuj dokument": "",
        "Edytuj filtr": "",
        "Edytuj kategorię": "",
        "Edytuj kontrahenta": "",
        "Edytuj pole": "",
        "Edytuj szablon": "",
        "Edytuj tabelę wektorową": "",
        "Edytuj uprawnienia": "",
        "Edytuj wersję": "",
        "Edytuj wpis": "",
        "Edytuj źródło danych": "",
        "Eksport": "",
        "Eksport danych został dodany.": "",
        "Eksport danych został zaktualizowany.": "",
        "Eksport do arkusza Excel": "",
        "Eksport do Excela": "",
        "Eksport dokumentów": "",
        "Eksport użytkowników": "",
        "Eksport wykonany pomyślnie": "",
        "Eksportuj": "",
        "Eksportuj diagram do XML": "",
        "Eksportuj do Excel": "",
        "Eksportuj wersję modułu do pliku": "",
        "Elastic": "",
        "Element sitemap": "",
        "Element został przywrócony.": "",
        "Element został usunięty.": "",
        "Elementu układu": "",
        "Eliminuj duplikaty z różnych serii danych": "",
        "Email": "",
        "Email potwierdzony": "",
        "Endpoint": "",
        "Endpoint API": "",
        "Endpoint został dodany.": "",
        "Endpoint został zaktualizowany.": "",
        "Error - błedy wewnętrze SDK": "",
        "Eskportuj": "",
        "Etykieta": "",
        "Etykiety": "",
        "Export XML": "",
        "Exportuj do Excela": "",
        "fakturę": "",
        "Fatal - błedy krytyczne": "",
        "Filtr dla synchronizacji działów": "",
        "Filtr dla synchronizacji użytkowników": "",
        "Filtr domyślny": "",
        "Filtr globalny": "",
        "Filtr po grupie": "",
        "Filtr prywatny": "",
        "Filtr został usunięty": "",
        "Filtr został zapisany": "",
        "Filtrowanie": "",
        "Filtrowanie listy dokumentów": "",
        "Filtruj": "",
        "Filtruj po roli": "",
        "filtry": "",
        "Filtry": "",
        "Filtry globalne": "",
        "Filtry systemowe": "",
        "Filtry wartościami pól formularza": "",
        "Finalizuję": "",
        "Folder OneDrive": "",
        "Folder plików": "",
        "Foldery": "",
        "Format dokumentu": "",
        "Formatowanie": "",
        "Formularz": "",
        "Formularz bazuje na nieaktualnej wersji definicji.": "",
        "Formularz dynamiczny": "",
        "Formularz zarchiwizowany": "",
        "Formularz zawiera błędy": "",
        "Formularz został dodany.": "",
        "Formularz został skopiowany.": "",
        "Formularz został wysłany pomyślnie": "",
        "Formularz został zaktualizowany.": "",
        "Formularz został zapisany": "",
        "Formularze": "",
        "Formularze i pola formularzy": "",
        "Formuła jest nieprawidłowa": "",
        "Funkcja": "",
        "Funkcja OCR nie jest włączona w konfiguracji systemu": "",
        "Funkcja została dodana.": "",
        "Funkcja została usunięta.": "",
        "Funkcja została zaktualizowana.": "",
        "Funkcje": "",
        "Funkcje Asystent": "",
        "Funkcje asystenta": "",
        "Funkcje Asystenta": "",
        "Funkcje asystenta AI": "",
        "Funkcjonalności": "",
        "Galeria zdjęć": "",
        "Gdzie zapisywać": "",
        "Generator obrazów AI": "",
        "Generowanie obrazów": "",
        "Generowanie obrazów zakończone.": "",
        "Generuj dokument z szablonu": "",
        "Generuj licznik sygnatury w skali miesiąca": "",
        "Generuj metadane": "",
        "Generuj metadane (AI)": "",
        "Generuj nowy obraz": "",
        "Generuj obraz": "",
        "GET: Lista wpisów (sortowanie i stronicowanie)": "",
        "GET: Pobranie danych": "",
        "GET: Pobranie wpisu": "",
        "GET: Schemat (definicja formularza)": "",
        "Godzina rozpoczęcia": "",
        "Godzina zakończenia": "",
        "Godziny": "",
        "Godziny robocze": "",
        "Google Translate V2": "",
        "GPT-4 Vision": "",
        "Graf statusów": "",
        "Grafika": "",
        "Grudzień": "",
        "Grupa": "",
        "Grupa użytkowników": "",
        "grupę": "",
        "Grupuj po": "",
        "Grupuj po okresie": "",
        "Grupuj pola": "",
        "Grupuj zadania po": "",
        "Grupy": "",
        "Grupy użytkowników": "",
        "Grupy użytkowników zostały zapisane": "",
        "Harmonogram zadań": "",
        "Harmonogram został zmieniony": "",
        "Hasło": "",
        "Hasło (Klucz ukryty)": "",
        "Hasło musi zawierać co najmniej jeden znak specjalny np.: ~ @ # $ % ^ & *": "",
        "Hasło użytkownika serwisowego": "",
        "Hasło zostało zmienione. Zaloguj się ponownie": "",
        "Health": "",
        "Heatmapa dla wersji": "",
        "Hierarchia": "",
        "Historia": "",
        "Historia logowania": "",
        "Historia zadania": "",
        "Historia zapytań AI": "",
        "Host": "",
        "Host dodatkowy": "",
        "Host główny": "",
        "i": "",
        "Id": "",
        "ID": "",
        "ID lub typ zadania": "",
        "Id modelu: %0": "",
        "Id obiektu": "",
        "Id sesji": "",
        "Id wpisu": "",
        "ID zadania": "",
        "Id zapytania": "",
        "Id zdarzenia": "",
        "Identyfikator": "",
        "Identyfikator przestrzeni (WorkspaceId)": "",
        "Identyfikator wdrożenia": "",
        "Identyfikator zadania": "",
        "Ideo": "",
        "Ikona": "",
        "Ikona nagłówka": "",
        "Ikonka": "",
        "Ilość cyfr w polu numer": "",
        "Ilość kont": "",
        "Ilość modułów": "",
        "Ilość wierszy": "",
        "Ilość wyników do odrzucenia": "",
        "Ilość wyników do pobrania": "",
        "Ilość znaków": "",
        "Ilość znaków odpowiedzi": "",
        "Imię": "",
        "Imię i Nazwisko": "",
        "Implementacja": "",
        "Implementacja metod/zmiennych/stałych, których chcemy używać w skrypcie": "",
        "Import": "",
        "Import danych": "",
        "Import dni wolnych": "",
        "Import modułu": "",
        "Import tabeli": "",
        "Import użytkowników": "",
        "Import w trakcie przetwarzania...": "",
        "Import wykonany pomyślnie": "",
        "Import zakończony pomyślnie.": "",
        "Import został dodany.": "",
        "Importer wprowadzi do systemu wszystkie wiersze, które przejdą walidację.": "",
        "Importuj": "",
        "Importuj definicję formularza": "",
        "Importuj moduł z pliku": "",
        "Importuj proces z pliku": "",
        "Importuj wersję z pliku": "",
        "Indeks": "",
        "Indeks został usunięty.": "",
        "info": "",
        "Info - informacje": "",
        "Informacja": "",
        "Informacyjna": "",
        "Inside": "",
        "Inspekcja": "",
        "Inspekcja pochodzenia uprawnienia": "",
        "Instalacja": "",
        "Instalacja rozszerzenia z Web Store": "",
        "Instrukcja": "",
        "Instrukcja (PDF)": "",
        "Instrukcja dla AI dotycząca tego pola": "",
        "Instrukcja modelu (prompt).": "",
        "Instrukcje dla pól": "",
        "Interpreter kodu": "",
        "Interpreter kodu umożliwia asystentowi pisanie i uruchamianie kodu. To narzędzie może przetwarzać pliki z różnymi danymi i formatowaniem oraz generować pliki.": "",
        "Istniejące firmy": "",
        "Jaki zakres danych": "",
        "Jakość": "",
        "Jakość HD 1024x1024": "",
        "Jakość HD 1024x1792 i 1792x1024": "",
        "Jakość rozpoznawania zależy od czytelności dokumentu. Najlepsze rezultaty uzyskasz z dokumentami w wysokiej rozdzielczości.": "",
        "Jakość standardowa 1024x1024": "",
        "Jakość standardowa 1024x1792 i 1792x1024": "",
        "Jakość wygnerowanego obrazu.": "",
        "Jasny": "",
        "Jedna kolumna": "",
        "Jest autorem": "",
        "Jeśli kolumna z tabeli nie jest uwzględniona w obiekcie to domyślnie jest ona widoczna.": "",
        "Jeśli kwota przekracza 2000": "",
        "Jeśli lista silników jest pusta, sprawdź czy został wybrany typ skryptu": "",
        "Jeśli pole jest puste, wówczas używana jest wartość domyślna. W przeciwnym wypadku wartość domyślna jest nadpisywana.": "",
        "Jeśli użytkownik należy do grupy użytkowników modułu o id 456": "",
        "Jeśli użytkownik należy do zespołu o id 456": "",
        "Jeśli w polu wyboru wybrano opcję 1": "",
        "Jeżeli": "",
        "Jeżeli aplikacja została prawidłowo zainstalowana i mimo tego nadal pojawia się niniejszy komunikat, należy sprawdzić czy na komputerze zainstalowane jest środowisko uruchomieniowe Java.": "",
        "Język": "",
        "Kafelki": "",
        "Kalendarz": "",
        "Kanał jest domyślnie wymagany. Nie da się wyłączyć wysyłania powiadomienia tym kanałem. Możliwa jest tylko zmiana tytułu i treści komunikatu.": "",
        "kanał wymagany": "",
        "Kanały": "",
        "Kanały komunikacji": "",
        "Kanały obsługiwane przez wybrany typ powiadmienia": "",
        "Kanały włączone w ustawieniach aplikacji": "",
        "Karta": "",
        "Katalog": "",
        "Katalog główny": "",
        "Katalog został utworzony": "",
        "Katalog został utworzony.": "",
        "Kategoria": "",
        "Kategoria archiwalna w innych komórkach": "",
        "Kategoria archiwalna w komórce macierzystej": "",
        "Kategoria została dodana.": "",
        "Kategoria została usunięta.": "",
        "Kategoria została zaktualizowana.": "",
        "Kategorie": "",
        "Kierownicy": "",
        "Kierownik": "",
        "Kierunek sortowania": "",
        "Klasyfikuję dokument": "",
        "Klienci": "",
        "Klient aktywny": "",
        "Klient został dodany.": "",
        "Klient został usunięty.": "",
        "Klient został zaktualizowany.": "",
        "Kliknij aby usunąć": "",
        "Klucz": "",
        "Klucz API": "",
        "Klucz główny (PrimaryKey)": "",
        "Klucz pola": "",
        "Klucz prywatny": "",
        "Klucz publiczny": "",
        "Klucze": "",
        "Klucze są nie prawidłowe.": "",
        "Klucze są prawidłowe.": "",
        "Klucze unikalne": "",
        "Kod musi kończyć się wyrażeniem, które zwraca wartość typu boolean": "",
        "Kod musi kończyć się wyrażeniem, które zwraca wartość typu boolean lub string": "",
        "Kod musi zwracać kończyć się wyrażeniem, które zwraca wartość wybranego typu": "",
        "Kod pocztowy": "",
        "Kod walidacji": "",
        "Kod wertfikacyjny": "",
        "Kod weryfikacyjny jest nieprawidłowy.": "",
        "Kod został skopiowany do schowka.": "",
        "Kod źródłowy": "",
        "Kolejka": "",
        "Kolejne osoby w procesie": "",
        "Kolekcja": "",
        "Kolekcja bazy wektorowej": "",
        "Kolor": "",
        "Kolor drugorzędny: %0": "",
        "Kolor etykiety": "",
        "Kolor icon na panelu z aplikacjami: %0": "",
        "Kolor ikony": "",
        "Kolor liczby": "",
        "Kolor podstawowy: %0": "",
        "Kolor przewodni obrazu": "",
        "Kolor tekstu aktywnej pozycji menu: %0": "",
        "Kolor tła panelu z aplikacjami: %0": "",
        "Kolor wartości": "",
        "Kolorowana konsola": "",
        "Kolory": "",
        "Kolory zostały przywrócone.": "",
        "Kolory zostały zapisane.": "",
        "Kolumna": "",
        "Kolumna do zsumowania": "",
        "Kolumny": "",
        "Kom": "",
        "Kom.": "",
        "Komentarz": "",
        "Komentarz został dodany.": "",
        "Komentarze": "",
        "Komponent którego wartość zostanie użyta jako nazwa elementu nadrzędnego. Dostępne tylko komponenty typu ``Tekst``.": "",
        "Komponent został dodany.": "",
        "Komponent został usunięty.": "",
        "Komponent został zaktualizowany.": "",
        "Komponent źródłowy": "",
        "Komponenty": "",
        "Komunikat": "",
        "Komunikat błędu": "",
        "Komunikat walidacji": "",
        "Konfiguracja": "",
        "Konfiguracja asystenta ai": "",
        "Konfiguracja dla stałych wartości, których chcemy używać w skrypcie": "",
        "Konfiguracja domyślna": "",
        "Konfiguracja harmonogramu": "",
        "Konfiguracja harmonogramu (czas UTC)": "",
        "Konfiguracja kolumn tabeli": "",
        "Konfiguracja list": "",
        "Konfiguracja logów": "",
        "Konfiguracja nie została ustawiona.": "",
        "Konfiguracja skryptu": "",
        "Konfiguracja strony": "",
        "Konfiguracja umożliwa wykorzystanie pól dokumentu do wygenrowania nazwy pliku. Przykład: Dokument @Model._1_Text1": "",
        "Konfiguracja zaawansowana": "",
        "Konfiguracja zapytania": "",
        "Konfiguracja została przywrócona dla reguł i celów": "",
        "Konfiguracja została zapisana.": "",
        "Koniec": "",
        "Koniec po": "",
        "Konta bez logowania": "",
        "Konta użytkowników": "",
        "Konta użytkowników zostały odblokowane": "",
        "Konta użytkowników zostały przypisane do zespołu": "",
        "Konta użytkowników zostały usunięte z systemu": "",
        "Konta użytkowników zostały zablokowane": "",
        "Kontakt": "",
        "Kontener plików": "",
        "Konto aktywne": "",
        "Konto bankowe": "",
        "Konto bez logowania": "",
        "Konto pozostanie nieaktywne dopóki adres e-mail nie zostanie potwierdzony": "",
        "Kontrahenci": "",
        "Kontrahent": "",
        "Kontrahent został nadpisany.": "",
        "Kontrahent został usunięty.": "",
        "Kontrahent został zapisany.": "",
        "Kontrolka": "",
        "Kontrolka wyboru": "",
        "Kontrolki no-code": "",
        "Kontrolki podstawowe": "",
        "Kontrolki specjalizowane": "",
        "Konwertuj obrazy do formatu WebP": "",
        "Końcowa": "",
        "Kopiuj": "",
        "Kopiuj adres": "",
        "Kopiuj definicję": "",
        "Kopiuj do schowka": "",
        "Kopiuj filtr": "",
        "Kopiuj JSON": "",
        "Kopiuj JSON do schowka": "",
        "Kopiuj pole": "",
        "Kopiuj sygnaturę": "",
        "Kopiuj z": "",
        "Kopiuj zaznaczony element": "",
        "Korzystaj ze zmiennych środowiskowych": "",
        "Kosz": "",
        "Kraj": "",
        "Krajowej Izby Rozliczeniowej S.A. ": "",
        "Krok": "",
        "Krok minut": "",
        "Krok minut musi być liczbą z zakresu od 1 do 60.": "",
        "Krok procesu": "",
        "Kroki": "",
        "Krótki opis": "",
        "KRS: ": "",
        "Kto dodaje": "",
        "Kto może udostępniać dokumenty": "",
        "Kto może wiązać dokumenty": "",
        "Kurs": "",
        "Kursy walut": "",
        "Kwiecień": "",
        "Kwota brutto": "",
        "Kwota netto": "",
        "Lasso – zaznaczanie elementów": "",
        "Layout": "",
        "LDAPS (LDAP over SSL)": "",
        "Lewy panel": "",
        "Licencja": "",
        "Licencja Logito": "",
        "Licencjobiorca": "",
        "Liczba": "",
        "Liczba całkowita": "",
        "Liczba danych wejściowych podana w tokenach.": "",
        "Liczba danych wyjściowych podana w tokenach.": "",
        "Liczba dni": "",
        "Liczba dni na wykonanie kroku": "",
        "Liczba dziesiętna": "",
        "Liczba miesięcy": "",
        "Liczba wariantów": "",
        "Liczba wyników na stronie": "",
        "Licznik zależny od": "",
        "Liczniki": "",
        "Lider": "",
        "light": "",
        "Limit": "",
        "Limit API": "",
        "Linia": "",
        "linie": "",
        "linię": "",
        "Link do użycia": "",
        "Link skopiowany": "",
        "Lipiec": "",
        "lista": "",
        "Lista": "",
        "Lista dozwolonych / wykluczonych żądań HTTP": "",
        "Lista efektywnych uprawnień użytkownika wynikających z uprawnień indywidualnych oraz ról.": "",
        "Lista elementów zostanie zawężona tylko do tych, które są pozwiązane z wybranymi wartościami z zaznaczonych komponentów.": "",
        "Lista ID": "",
        "Lista indeksów": "",
        "Lista jest pusta": "",
        "Lista kontahentów": "",
        "Lista kontrahentów": "",
        "Lista plików": "",
        "Lista powiadomień": "",
        "Lista pracowników": "",
        "Lista rozwijana": "",
        "Listopad": "",
        "Listy": "",
        "Litery": "",
        "Litery i cyfry": "",
        "Log Analytics": "",
        "Logi": "",
        "Logi błędów": "",
        "Logi wydajnościowe": "",
        "Login": "",
        "Logito": "",
        "Logito Asystent AI": "",
        "Logo": "",
        "Logowanie": "",
        "Logowanie zakończyło się niepowodzeniem.": "",
        "Logowanie zależności / żądań typu HTTP": "",
        "Loguj wybrane": "",
        "Lokalne": "",
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit.": "",
        "Lorem ipsum dolor sit, amet consectetur adipisicing elit.": "",
        "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Quam commodi autem id, veniam, illum temporibus.": "",
        "Lp.": "",
        "lub": "",
        "Luty": "",
        "Ładowanie błędów...": "",
        "Ładowanie danych...": "",
        "Ładowanie logów...": "",
        "Ładowanie szczegółów...": "",
        "Ładowanie task listy": "",
        "Ładowanie...": "",
        "Łączenie treści": "",
        "Łączny czas": "",
        "Ma dostęp do dokumentu": "",
        "Maj": "",
        "Maksimum": "",
        "Maksymalna ilość plików": "",
        "Maksymalna rozdzielość %0x%1px": "",
        "Maksymalna szerokość kolumny (px)": "",
        "Maksymalnie można wprowadzić 500 znaków": "",
        "Maksymalny rozmiar pliku w MB": "",
        "Maksymalny rozmiar pliku: %0MB.": "",
        "Mała": "",
        "Małe znaki": "",
        "Mały": "",
        "Mały układ siatki": "",
        "Mapowanie": "",
        "Mappingi": "",
        "Mapuję dane na odpowiednie pola...": "",
        "Marzec": "",
        "Mediana": "",
        "Metadane": "",
        "Metoda": "",
        "Metoda autentykacji": "",
        "Metoda musi zwracać obiekt \"entry.errors\".": "",
        "Metody": "",
        "Miara podobieństwa (Wrtość od 1 do 5, gdzie 1 to największa dokładność)": "",
        "Miasto": "",
        "Miejsca po przecinku": "",
        "Miejsce pracy": "",
        "Miejscowość": "",
        "mies.": "",
        "miesiąc": "",
        "Miesiąc": "",
        "Miesiące": "",
        "Miesięczny": "",
        "Migracje": "",
        "Min. ilość elementów podobnych wymagana do automatyzacji": "",
        "Miniaturki": "",
        "Minimalna długość hasła": "",
        "Minimalna szerokość kolumny (px)": "",
        "Minimum": "",
        "Minuty": "",
        "Mnożenie": "",
        "Model": "",
        "Model danych": "",
        "Moderacja danych wejściowych": "",
        "Moduł": "",
        "Moduł domyślny dla wsparcia AI": "",
        "Moduł dynamiczny": "",
        "Moduł jest wymagany": "",
        "Moduł statyczny": "",
        "Moduł został dodany.": "",
        "Moduł został usunięty.": "",
        "Moduł został wyeksportowany.": "",
        "Moduł został zaktualizowany.": "",
        "Moduł został zapisany.": "",
        "Moduł został zmieniony pomyślnie.": "",
        "Moduły": "",
        "Modyfikacja": "",
        "Modyfikacja dokumentów": "",
        "Modyfikuj aktywny filtr": "",
        "Modyfikuj istniejący wątek": "",
        "Moje aplikacje": "",
        "Moje dokumenty": "",
        "Moje filtry": "",
        "Moje konto": "",
        "Moje pliki": "",
        "Moje zadania": "",
        "Monitor kolejek": "",
        "Monitoring": "",
        "Monitoruj statystyki .NET": "",
        "Monitoruj żądania HTTP": "",
        "Może zarządzać dokumentami w rejestrze.": "",
        "Może zarządzać fakturami w rejestrze. Powiązane z uprawnieniami \"Może dodawać\", \"Koordynator\", \"Księgowa\".": "",
        "Może zarządzać pismami w rejestrze. Powiązane z opcjami dodawania, przypisywania po przyjęciu, edycji.": "",
        "Może zarządzać pismami w rejestrze. Powiązane z opcją dodawania pism. Edycja dostępna jest tylko dla autora. Wysyłanie i dodawanie zwrotek.": "",
        "Może zarządzać rejestrem": "",
        "Może zarządzać reklamacjami w rejestrze. Powiązane z uprawnieniami \"Może dodawać\", \"Koordynator\", \"Specialista przepływu statusów\".": "",
        "Może zarządzać umowami w rejestrze. Powiązane z opcją dodawania umów.": "",
        "Możesz podać nową nazwę pliku.": "",
        "Możesz wybrać maksymalnie 10 elementów": "",
        "Możliwość modyfikacji tego działu jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "",
        "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "",
        "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są synchronizowane z zewnętrzną bazą danych %0.": "",
        "Możliwość wielokrotnego wyboru": "",
        "Mój tytuł": "",
        "MPK": "",
        "Musisz wybrać przynajmniej jedną grupę.": "",
        "Na diagramie procesu występują błędy. Sprawdź zakładkę \"Błędy\"": "",
        "Na pewno usunąć wybrane elementy?": "",
        "Na widoku nie będą dostępne akcje dokumentów łącznie z linkiem do szczegółów": "",
        "Nadaj dostęp do dokumentów powiązanych osobom, które mają dostęp do dokumentu głównego": "",
        "Nadawanie uprawnień do dokumentów": "",
        "Nadawanie uprawnień do własnych dokumentów": "",
        "Nadawanie uprawnień do wszystkich dokumentów": "",
        "Nadawca": "",
        "Nadpisz": "",
        "Nadpisz konfigurację": "",
        "Nadpisz skrypt": "",
        "Nadpisz skrypt po przetworzeniu dokumentu": "",
        "Nadpisz skrypt współdzielony": "",
        "Nagłówek": "",
        "Nagłówek dokumentu": "",
        "Najstarsza wiadomość": "",
        "Należy wybrać moduł": "",
        "Należy wybrać silnik skryptowy": "",
        "Nałóż warstwę tekstową dla plików PDF": "",
        "Narzędzia": "",
        "Narzędzie integruje się z platformą SMSAPI.pl": "",
        "Następna": "",
        "Następna strona": "",
        "Nazwa": "",
        "Nazwa (wymagane)": "",
        "Nazwa aliasu": "",
        "Nazwa asystenta": "",
        "Nazwa bazy danych": "",
        "Nazwa działu": "",
        "Nazwa filtra": "",
        "Nazwa formularza": "",
        "Nazwa funkcji": "",
        "Nazwa indeksu": "",
        "Nazwa jest wymagana": "",
        "Nazwa katalogu": "",
        "Nazwa katalogu została zmieniona.": "",
        "Nazwa klienta": "",
        "Nazwa kolumny": "",
        "Nazwa kolumny jest wymagana.": "",
        "Nazwa kolumny z opisem": "",
        "Nazwa kolumny z wartością": "",
        "Nazwa komponentu": "",
        "Nazwa konta (Klucz dostępu)": "",
        "Nazwa kontrahenta": "",
        "Nazwa modelu": "",
        "Nazwa modułu": "",
        "Nazwa musi mieć co najmniej 3 znaki": "",
        "Nazwa musi mieć co najmniej 5 znaków": "",
        "Nazwa na grafie": "",
        "Nazwa nadawcy": "",
        "Nazwa narzędzia": "",
        "Nazwa nie może być dłuższa niż 30 znaków": "",
        "Nazwa nie może być dłuższy niż 50 znaków": "",
        "Nazwa pliku": "",
        "Nazwa pliku została zmieniona.": "",
        "Nazwa pola": "",
        "Nazwa pola na formularzu": "",
        "Nazwa pola z różnicą": "",
        "Nazwa pola z sumą": "",
        "Nazwa powiadomienia": "",
        "Nazwa przycisku": "",
        "Nazwa przycisku ``Dalej``": "",
        "Nazwa przycisku ``Wstecz``": "",
        "Nazwa przycisku ``Wyślij``": "",
        "Nazwa przycisku na formularzu": "",
        "Nazwa roli": "",
        "Nazwa sekcji w menu": "",
        "Nazwa sekcji...": "",
        "Nazwa serii": "",
        "Nazwa serwera": "",
        "Nazwa skrócona": "",
        "Nazwa spółki": "",
        "Nazwa szablonu": "",
        "Nazwa typu": "",
        "Nazwa urządzenia": "",
        "Nazwa użytkownika": "",
        "Nazwa użytkownika serwisowego": "",
        "Nazwa w indeksie": "",
        "Nazwa wątku": "",
        "Nazwa webhooka": "",
        "Nazwa wersji": "",
        "Nazwa zadania": "",
        "Nazwa zakładki": "",
        "Nazwa zasobu": "",
        "Nazwa zespołu": "",
        "Nazwa źródła": "",
        "Nazwa źródła danych": "",
        "Nazwisko": "",
        "Nazwy wartości": "",
        "Nicość - nie zapisuj": "",
        "Nie": "",
        "Nie loguj wybranych": "",
        "Nie ma użytkowników, którym można odebrać uprawnienia do dokumentu": "",
        "Nie masz uprawnień do panelu administracyjnego.": "",
        "Nie masz uprawnień do tego dokumentu": "",
        "Nie masz uprawnień do tego widoku. Stan widoku mógł ulec zmianie, odśwież i sprawdź lub spróbuj ponownie później.": "",
        "Nie możesz dodać tego samego widgetu dwa razy": "",
        "Nie możesz modyfikować profilu zastępowanego użytkownika.": "",
        "Nie możesz modyfikować uprawnień": "",
        "Nie można usunąć swojego konta.": "",
        "Nie odnaleziono kontrahenta o podanym numerze NIP w bazie GUS.": "",
        "Nie podano ID procesu, którego dotyczy formularz": "",
        "Nie podano wymaganej ilości znaków: %0.": "",
        "Nie stosuj pogrubienia do nieodczytanych dokumentów.": "",
        "Nie udało się dopasować do modułu. Dokument trafił do modułu domyślnego:": "",
        "Nie udało się pobrać akcji": "",
        "Nie udało się pobrać historii": "",
        "Nie udało się pobrać listy celów": "",
        "Nie udało się pobrać listy działów": "",
        "Nie udało się pobrać listy filtrów": "",
        "Nie udało się pobrać listy kanałów": "",
        "Nie udało się pobrać listy kolejek": "",
        "Nie udało się pobrać listy powiadomień": "",
        "Nie udało się pobrać listy ról": "",
        "Nie udało się pobrać listy serwerów baz danych": "",
        "Nie udało się pobrać listy serwerów plików": "",
        "Nie udało się pobrać listy spółek": "",
        "Nie udało się pobrać listy typów danych.": "",
        "Nie udało się pobrać listy typów modeli": "",
        "Nie udało się pobrać listy wpisów.": "",
        "Nie udało się pobrać listy wydziałów": "",
        "Nie udało się pobrać listy zespołów": "",
        "Nie udało się pobrać logów": "",
        "Nie udało się pobrać logów procesu": "",
        "Nie udało się pobrać obrazu.": "",
        "Nie udało się pobrać powiadomień.": "",
        "Nie udało się pobrać szczegółów": "",
        "Nie udało się pobrać szczegółów logu": "",
        "Nie udało się pobrać url do podpisu dokumentu": "",
        "Nie udało się pobrać ustawień kont użytkowników": "",
        "Nie udało się pobrać widgetu/ów": "",
        "Nie udało się skopiować do schowka": "",
        "Nie udało się usunąć szablonu": "",
        "Nie udało się utworzyć nowej wersji": "",
        "Nie udało się wyeksportować pliku XML.": "",
        "Nie udało się wykonać akcji": "",
        "Nie udało się wysłać pliku": "",
        "Nie udało się załadować diagramu procesu.": "",
        "Nie udało się załadować Szafir Host. Zamknij aplikację do podpisów, jeśli jest otwarta, odśweiż stronę i wykonaj akcję ponownie.": "",
        "Nie udało się załadować widgetu AI.": "",
        "Nie udało się zapisać filtra": "",
        "Nie udało się zapisać formularza": "",
        "Nie udało się zapisać szablonu": "",
        "Nie wszystkie pola zostały wypelnione prawidłowo.": "",
        "Nie wszystkie pola zostały wypełnione prawidłowo": "",
        "Nie wszystkie pola zostały wypełnione prawidłowo.": "",
        "Nie wszystkie wybrane elementy zostały przeniesione. Nie posiadasz wymaganych uprawnień lub, w przypadku przenoszenia katalogów, katalog docelowy jest podkatalogiem katalogu źródłowego. Katalogi i pliki których nie udało się przenieść pozostały nadal w zakładce Wybrane.": "",
        "Nie wszystkie wymagane pola zostały wypełnione": "",
        "Nie wybrano żadnego użytkownika.": "",
        "Nie wybrano żadnych filtrów": "",
        "Nie wygenerowano żadnej task listy.": "",
        "Nie wymaga uwierzytelniania": "",
        "nie wymuszaj zmiany hasła": "",
        "Nie zdefiniowano żadnych ról.": "",
        "Nie zdefiniowano żadnych spółek.": "",
        "Nie znaleziono dostępnych widgetów": "",
        "Nie znaleziono filtrów.": "",
        "Nie znaleziono formularza.": "",
        "Nie znaleziono kolumn.": "",
        "Nie znaleziono pasującego widgetu": "",
        "Nie znaleziono pasujących elementów.": "",
        "Nie znaleziono szczegółów logu": "",
        "Nie znaleziono żadnego pola.": "",
        "Nie znaleziono żadnych akcji": "",
        "Nie znaleziono żadnych plików": "",
        "Nie znaleziono żadnych użytkowników.": "",
        "Nie znaleziono żadnych wyników.": "",
        "Nieaktywne": "",
        "Nieaktywni": "",
        "Nieaktywny": "",
        "niedozwolone rozszerzenie pliku (%0)": "",
        "niedozwolony typ pliku (%0)": "",
        "Niedziela": "",
        "Nieopublikowany": "",
        "Niepoprawna nazwa kolumny.": "",
        "Niepoprawne wyrażenie regularne": "",
        "Niepotwierdzeni": "",
        "Nieprawidłowa definicja": "",
        "Nieprawidłowy adres email": "",
        "Nieprawidłowy adres URL": "",
        "Nieprawidłowy format dokumentu. Aby podpisać dokument przekonwertuj go na format PDF": "",
        "Nieprawidłowy lub wygasły token dostępu": "",
        "Nieprzeczytane": "",
        "Niestandardowy błąd": "",
        "Nieudane": "",
        "Nieudane próby logowania": "",
        "Niewidoczne": "",
        "Nieznane narzędzie": "",
        "Nieznany model": "",
        "Nieznany typ pliku": "",
        "Nigdy": "",
        "Nikomu nie przydzielono uprawnień": "",
        "Niniejsza strona wykorzystuje komponenty podpisu elektronicznego ": "",
        "NIP": "",
        "NIP: ": "",
        "no-store (wyłącza cache)": "",
        "Nowa data": "",
        "Nowe hasło": "",
        "Nowi akceptanci": "",
        "np. (&(objectClass=organizationalUnit))": "",
        "np. (&(objectClass=user)": "",
        "Nr budynku": "",
        "Nr konta bankowego": "",
        "Nr lokalu": "",
        "Nr telefonu": "",
        "Numer budynku": "",
        "Numer dokumentu będzie uzupełniany zerami wiodącymi": "",
        "Numer domu": "",
        "Numer kolejny": "",
        "Numer KRS": "",
        "Numer lokalu": "",
        "Numer mieszkania": "",
        "Numer osobowy HCM": "",
        "Numer pokoju": "",
        "Numer REGON": "",
        "Numer sesji": "",
        "Numer telefonu": "",
        "Numeruj używając licznika wg daty": "",
        "OAuth2 dla Exchange Online": "",
        "Obecnie edytowana wersja procesu jest używana w wersjach modułu": "",
        "Obiekt": "",
        "Obiekt %0 został %1": "",
        "Obiekt ma strukturę Dictionary<string, object>[] z C#": "",
        "Obliczenie godzin między datami z pierwszego i ostatniego wiersza": "",
        "Obok siebie": "",
        "Obraz został pomyślnie opisany": "",
        "Obraz został wycięty.": "",
        "Obraz został wygenerowany.": "",
        "Obsługiwane formaty plików: txt, md, pdf, docx.": "",
        "OCR": "",
        "Oczekuje na akceptacje": "",
        "Oczekuje na wysłanie": "",
        "od": "",
        "Od": "",
        "od %0": "",
        "Odbierz uprawnienia do dokumentu": "",
        "Odbierz uprawnienie": "",
        "Odbiorca": "",
        "Odblokuj": "",
        "Odczytuję informacje z dokumentu...": "",
        "Oddalenie diagramu": "",
        "Odejmowanie": "",
        "Odpowiedzi": "",
        "Odpowiedzi: %0 na %1": "",
        "Odpowiedź": "",
        "Odpowiedź dowolna": "",
        "Odrzucone": "",
        "Odrzucono:": "",
        "Odrzucony": "",
        "Odrzuć": "",
        "Odstęp": "",
        "Odśwież": "",
        "Odtwórz indeks": "",
        "Odtwórz wszystkie indeksy": "",
        "Odwołanie do klucza pierwszego wybranego terminu słownika w polu Słownik Logito": "",
        "Odwołanie do pól terminu słownika (np. stawka VAT)": "",
        "Odwołanie do wartości pola numerycznego": "",
        "Odznacz": "",
        "Odznacz wszystkie": "",
        "Ogólne": "",
        "Ok": "",
        "Omnitool": "",
        "OneDrive": "",
        "Opcje": "",
        "OpenAI": "",
        "Operacje": "",
        "Operator.!.(Dokument.Pola dokumentu.{Nazwa pola})": "",
        "Opiekun": "",
        "Opis": "",
        "Opis błędu": "",
        "Opis faktury": "",
        "Opis funkcji": "",
        "Opis kodami kontrolingowymi": "",
        "Opis obrazu": "",
        "Opis pola (drobny tekst pod polem na formularzu)": "",
        "Opis skrócony": "",
        "Opis zespołu": "",
        "Opis źródła": "",
        "Opisy": "",
        "Optymalizuj rozdzielczość obrazów": "",
        "Opublikowano wersję": "",
        "Opublikowany": "",
        "oraz": "",
        "oraz aplikacji udostępniającej funkcje podpisu elektronicznego.": "",
        "Oraz hasło": "",
        "Oraz nowe hasło": "",
        "Organizacja": "",
        "Organizacja została usunięta.": "",
        "Orientacja wydruku": "",
        "OriginId": "",
        "Osoba": "",
        "Osoba zastępowana": "",
        "Osoba zastępująca": "",
        "Osoby które mają dostęp do dokumentu": "",
        "Osoby które realizują obecnie zadanie w obiegu dokumentu": "",
        "Osoby zaproszone": "",
        "Ostatnia aktywność": "",
        "Ostatnia strona": "",
        "ostatnie sprawdzenie": "",
        "Ostatnio dodane": "",
        "Ostrzeżenia": "",
        "Ostrzeżenie": "",
        "Otwórz": "",
        "Otwórz heatmapę": "",
        "Otwórz licznik na kolejny miesiąc": "",
        "Otwórz licznik na kolejny rok": "",
        "Otwórz modal po wykonaniu akcji": "",
        "Otwórz wyszukiwarkę": "",
        "Oznacz": "",
        "Oznacz jako nieodczytany": "",
        "Oznacz jako nieprzeczytane": "",
        "Oznacz jako przeczytane": "",
        "Oznacz powiadomienia": "",
        "Oznacz wszystkie jako przeczytane": "",
        "Oznacz wybrane jako nieprzeczytane": "",
        "Oznacz wybrane jako przeczytane": "",
        "Paleta kolorów": "",
        "Parametry funkcji": "",
        "Parametry, wymagane do wykonania zapytania:": "",
        "Pasek": "",
        "Pasek postępu": "",
        "Październik": "",
        "Pełne dane": "",
        "Pełny": "",
        "PESEL": "",
        "PESEL: ": "",
        "PH": "",
        "Piątek": "",
        "Pierwiastkowanie wartości kolumny": "",
        "Pierwsza strona": "",
        "Pigułki": "",
        "Piktogram": "",
        "pismo przychodzące": "",
        "Plik audio": "",
        "Plik binarny": "",
        "Plik CSS": "",
        "Plik CSV": "",
        "Plik DOC": "",
        "Plik DOCX": "",
        "Plik GIF": "",
        "Plik HTML": "",
        "Plik importowy": "",
        "Plik jest wysyłany": "",
        "Plik JPEG": "",
        "Plik JPG": "",
        "Plik MP4": "",
        "Plik PNG": "",
        "Plik skompresowany": "",
        "Plik tekstowy json": "",
        "Plik tekstowy txt": "",
        "Plik zawiera niepoprawne dane w komórkach": "",
        "Plik ZIP": "",
        "Plik został dodany.": "",
        "Plik został usunięty.": "",
        "Plik został wysłany": "",
        "Pliki": "",
        "Pliki Asystent": "",
        "Pliki Asystenta": "",
        "Pliki asystenta AI": "",
        "Pliki do wysłania: %0": "",
        "Pliki prywatne": "",
        "Pliki publiczne": "",
        "Pliki współdzielone": "",
        "Pliki: %0": "",
        "po %0 nieudanych próbach logowania": "",
        "Po jednym synonimie w wierszu": "",
        "Po wybraniu tej opcji konta użytkowników zostaną usunięte z systemu. Czy chcesz kontynuować?": "",
        "Po zainstalowaniu aplikacji Szafir Host przeładuj bieżącą stronę!": "",
        "Po zainstalowaniu rozszerzenia należy przeładować bieżącą stronę!": "",
        "Po zakończonym imporcie wyświetli się podsumowanie o ilości zaimportowanych/odrzuconych rekordów oraz lista błędów dla wierszy odrzuconych": "",
        "Po zaznaczeniu tej opcji uprawnienia indywidualne i pochodzące z ról nie są brane pod uwagę.": "",
        "Pobierz": "",
        "Pobierz dane z GUS": "",
        "Pobierz i zainstaluj aplikację": "",
        "Pobierz raport błędów": "",
        "Pobierz szablon": "",
        "Początkowa ilość wierszy": "",
        "Poczta": "",
        "Pod zmienną Entry dostępne są także dane formularza": "",
        "Podaj NIP": "",
        "Podaj nową nazwę": "",
        "Podaj swój adres email": "",
        "Podana nazwa jest zajęta.": "",
        "Podana wartość jest nieprawidłowa.": "",
        "Podanie nazwy jest wymagane.": "",
        "Podano adres": "",
        "Podano nieprawidłowe dane": "",
        "Podano nieprawidłowe dane.": "",
        "Podczas pierszego uruchomienia wymagane jest utworzenie konta głównego administratora.": "",
        "Podczas wykonywania skryptu lub service taska na tej akcji wystąpił błąd.": "",
        "Podgląd": "",
        "Podgląd dokumentu": "",
        "Podgląd formularza": "",
        "Podgląd jest dostępny jedynie po zapisaniu szablonu": "",
        "Podgląd niedostępny w trybie projektowania": "",
        "Podgląd przycisku": "",
        "Podgląd tabeli": "",
        "Podkreślenie": "",
        "Podpis": "",
        "Podpis dokumentu": "",
        "Podpis elektroniczny Szafir SDK": "",
        "Podpisz dokument": "",
        "Podstawowe": "",
        "Podstawowe operacje na datach": "",
        "Podstawowe operacje na liczbach": "",
        "Podstawowe operacje tekstowe": "",
        "Podstawowe operacje warunkowe": "",
        "Podstawowy": "",
        "Podsumowanie dla całego zestawu danych": "",
        "Podsumowanie dla strony": "",
        "Podsumowanie kolumn": "",
        "Podwładni": "",
        "Podział na pliki": "",
        "Podziedziałek - Piątek": "",
        "Podziel widok terminarza wg": "",
        "Pogrubienie etykiety": "",
        "Pogrubienie wartości": "",
        "Pojedynczy dokument": "",
        "Pojedynczy wybór": "",
        "Pokazuj wszystkie": "",
        "Pokazuj wybrane": "",
        "Pokazywane są tylko rekordy, gdzie różnica jest różna od 0": "",
        "Pokaż": "",
        "Pokaż etykietę": "",
        "Pokaż etykietę nad wartością": "",
        "Pokaż etykiety bez wartości": "",
        "Pokaż filtry": "",
        "Pokaż filtry na liście": "",
        "Pokaż fukncję dowiązania dokumentów wg uprawnień": "",
        "Pokaż godziny robocze": "",
        "Pokaż heatmapę": "",
        "Pokaż historię": "",
        "Pokaż ikonę": "",
        "Pokaż kolumnę z liczbą porządkową": "",
        "Pokaż numer tygodnia na kalendarzu": "",
        "Pokaż numery stron": "",
        "Pokaż pager": "",
        "Pokaż pełne godziny": "",
        "Pokaż pochodzenie uprawnienia": "",
        "Pokaż przycisk ``Wyślij``": "",
        "Pokaż przycisk akcji": "",
        "Pokaż przycisk dla akcji": "",
        "Pokaż przycisk operacji grupowych": "",
        "Pokaż tylko moje dokumenty": "",
        "Pokaż tytuł": "",
        "Pokaż tytuł formularza": "",
        "Pokaż tytuł sekcji": "",
        "Pokaż tytuł strony": "",
        "Pokaż tytuły stron": "",
        "Pokaż w koncie użytkownika": "",
        "Pokaż wartości na wykresie": "",
        "Pokaż więcej": "",
        "Pokaż więcej komentarzy": "",
        "pokaż więcej...": "",
        "Pokaż Wykres pod tabelą": "",
        "Pokaż załączniki dokumentów powiązanych": "",
        "Pokaż załączniki dokumentu": "",
        "Pokój": "",
        "Pola": "",
        "Pola do wyświetlania": "",
        "Pola do wyświetlenia": "",
        "Pola do zgrupowania": "",
        "Pola dokumentu": "",
        "Pola formularzy": "",
        "Pola mapowane": "",
        "Pola mapowane (excel)": "",
        "Pola należące do grupy": "",
        "Pola opisujące wiadomość": "",
        "Pola systemowe": "",
        "Pola tekstowe": "",
        "Pola wspólne": "",
        "Pola wyliczane": "",
        "Pola wyświetlane": "",
        "Pola z formularza: ": "",
        "Pola zgrupowane": "",
        "Pola zostały zgrupowane.": "",
        "Pola źródłowe": "",
        "Pole": "",
        "Pole \"%0\" jest wymagane.": "",
        "Pole \"%0\" nie zawiera prawidłowego adresu email.": "",
        "Pole \"%0\" nie zawiera prawidłowego adresu URL.": "",
        "Pole \"%0\" zawiera niedozwoloną wartość.": "",
        "Pole \"Drugie imię\" jest wymagane.": "",
        "Pole \"Imię\" jest wymagane.": "",
        "Pole \"Nazwisko\" jest wymagane.": "",
        "Pole \"Tytuł\" jest wymagane.": "",
        "Pole do mapowania importu Excel": "",
        "Pole do wyliczenia": "",
        "Pole dotyczy tabeli VAT, prompt jest dodawany automatycznie przez system": "",
        "Pole formularza": "",
        "Pole jest wymagane": "",
        "Pole kwoty docelowej": "",
        "Pole kwoty źródłowej": "",
        "Pole może zawierać jedynie cyfry.": "",
        "Pole może zawierać jedynie litery i cyfry.": "",
        "Pole może zawierać jedynie litery.": "",
        "Pole może zawierać tylko ciało metody walidującej dane w postaci natywnego kodu JavaScript.": "",
        "Pole na zapis wydruku": "",
        "Pole nie może zawierać spacji": "",
        "Pole powiązane": "",
        "Pole powiązania dokumentu": "",
        "Pole priorytetowe": "",
        "Pole skopiowane": "",
        "Pole tekstowe": "",
        "Pole typu \"%0\" jest niedozwolone w tym formularzu.": "",
        "Pole wspólne zostało dodane.": "",
        "Pole wspólne zostało usunięte": "",
        "Pole wspólne zostało zaktualizowane.": "",
        "Pole wymagane": "",
        "Pole z argumentem": "",
        "Pole z datą": "",
        "Pole z datą wg której liczymy kurs": "",
        "Pole z dokumentem": "",
        "Pole z rozwiązaniem": "",
        "Pole z wartością do walidacjij": "",
        "Pole z załącznikami": "",
        "Pole zawiera": "",
        "Pole ze zdjęciami": "",
        "Pole ze zdjęciem głównym": "",
        "Pole zostało rozgrupowane.": "",
        "Pole zostało zaktualizowane.": "",
        "Polityka prywatności": "",
        "Polski": "",
        "Połącz – szybkie łączenie bloków": "",
        "Pomiędzy": "",
        "Pomijanie kolejkowania": "",
        "Pomiń pierwszy wiersz excela": "",
        "Pomiń wysłanie powiadomienia w przypadku braku dokumentów": "",
        "Pomoc": "",
        "Pomyślnie przywrócono konfigurację domyślną": "",
        "Pomyślnie uruchomiono proces reindeksacji": "",
        "Pomyślnie usunięto rekord": "",
        "Pomyślnie usunięto wersje": "",
        "Pomyślnie zapisano konfigurację filtrów": "",
        "Pomyślnie zapisano konfigurację kolumn": "",
        "Pomyślnie zmieniono akceptantów w %0 dokumentach": "",
        "Poniedziałek": "",
        "Ponów cofniętą operację": "",
        "Poprawne": "",
        "Poprawny": "",
        "Poprzednia": "",
        "Poprzednia strona": "",
        "Porównaj %0": "",
        "Porównaj z edytowaną wersją": "",
        "Porównania": "",
        "Porównanie": "",
        "Porównywana wersja": "",
        "Port": "",
        "Portal Pracowniczy (SSO)": "",
        "Posiada załączniki": "",
        "Posiadasz nieaktualną wersję aplikacji": "",
        "POST: Lista wpisów (dowolne wyszukiwanie)": "",
        "POST: Upload załączników": "",
        "POST: Utworzenie wpisu": "",
        "POST: Zapisanie zmian": "",
        "Potwierdzenia": "",
        "Potwierdzenie przywrócenia": "",
        "Potwierdzenie usunięcia": "",
        "Potwierdzenie wylogowania użytkownika": "",
        "Potwierdzenie zmiany statusu": "",
        "Potwierdź": "",
        "Potwierdź akceptację": "",
        "Powiadomienia": "",
        "Powiadomienia weryfikacyjne": "",
        "Powiadomienia zbiorcze": "",
        "Powiadomienia zostały skonfigurowane.": "",
        "Powiadomienie jest domyślnie wymagane. Nie da się wyłączyć wysyłania tego powiadomienia.": "",
        "Powiadomienie testowe zostało wysłane.": "",
        "Powiadomienie weryfikacyjne": "",
        "Powiadomienie zostało usunięte": "",
        "Powiązane dokumenty": "",
        "Powiąż": "",
        "Powiąż dokument": "",
        "Powiąż z polem typu grupa użytkowników": "",
        "Powiąż ze spółką": "",
        "Powiększ": "",
        "Powinno się dodać dyrektywę PRIVATE dla treści personalizowanych dla użytkownika, zwłaszcza dla odpowiedzi otrzymywanych po zalogowaniu i z uwzględnieniem uprawnień.": "",
        "powrót": "",
        "Powrót": "",
        "Powtarzaj co": "",
        "Powtórz hasło": "",
        "Powtórzone": "",
        "Powyższe obiekty zawierają tylko właściwości i są pozbawione wszystkich metod.": "",
        "Poziom dostępu do webhooka": "",
        "Poziom dostępu użytkownika": "",
        "Poziom logowania błedów": "",
        "Poziomy logowania": "",
        "Pozostałe": "",
        "Pozostało %0 znaków.": "",
        "Pozostawienie pola pustego spowoduje, że przyjmowane będą wszystkie rozszerzenia": "",
        "Pozwalaj na grupowe wykonanie akcji": "",
        "Pozwalaj na równoległe wykonanie grupowej akcji": "",
        "Pozwalaj wiązać tylko niezakończone dokumenty": "",
        "Pozwól dodawać terminy użytkownikom": "",
        "Pozwól na dodawanie wierszy": "",
        "Pozwól na kopiowanie": "",
        "Pozwól na kopiowanie pól numerycznych w tabeli": "",
        "Pozwól na uzupełnianie danych z pliku excel": "",
        "pół roku": "",
        "Półroczny": "",
        "Pracownicy": "",
        "Pracownik": "",
        "Prawy panel": "",
        "Predefiniowane tła panelu z aplikacjami": "",
        "Predefiniowane zestawy kolorów": "",
        "Preferowany język": "",
        "Prezentacja": "",
        "primary": "",
        "Priorytet": "",
        "private (tylko cache przeglądarki)": "",
        "Procent": "",
        "Procent całości": "",
        "Procent kolumny": "",
        "Proces": "",
        "Proces i elementy podstawowe (statusy, czynności, akcje, grupy użytkowników)": "",
        "Proces został dodany.": "",
        "Proces został edytowany.": "",
        "Proces został zapisany.": "",
        "Proces.Grupa użytkowników.{Nazwa grupy}": "",
        "Proces.Krok.{Nazwa akcji}.Proces.Pola formularza.{Nazwa pola}": "",
        "Proces.Osoba wykonująca krok.{Nazwa akcji}": "",
        "Proces.Zmienne(typ).{operator}.Dokument.Pole dokumentu.{Nazwa pola}": "",
        "Proces.Zmienne(typ).{operator}.Proces.Pola formularza.{Nazwa pola}": "",
        "Profil użytkownika": "",
        "Profil został zaktualizowany.": "",
        "Projekt": "",
        "Prometheus": "",
        "Prompt informacyjny": "",
        "Prompt klasyfikacyjny": "",
        "Prompt systemowy": "",
        "Prompt z instrukcją": "",
        "Propka": "",
        "Propki": "",
        "Proporcje obrazu": "",
        "Proste uprawnienia": "",
        "Próbkowanie": "",
        "Prywatne": "",
        "Przebudowanie indeksów": "",
        "Przebudowanie indeksównnOperacja może trwać od kilku sekund do kilku godzin w zależności od rozmiaru indeksów.nnNależy używać tylko w przypadku konieczności zaaplikowania zmian dokonanych w słownikach synonimów lub słów wykluczonych.": "",
        "Przeciągnij i upuść aby posortować pliki": "",
        "Przeczytane": "",
        "przed": "",
        "Przedrostek": "",
        "Przeglądarka wymaga zainstalowania dedykowanej aplikacji": "",
        "Przeglądarka z której korzystasz nie wspiera powiadomień PUSH": "",
        "Przeindeksowanie danych": "",
        "Przeindeksowanie danychnnOperacja może trwać od kilku sekund do kilku godzin w zależności od ilości danych w bazie.nnNależy używać tylko w przypadku zauważenia braku danych w indeksach.": "",
        "Przejdź do konfiguracji, aby włączyć narzędzia": "",
        "Przekaż do właściciela": "",
        "Przekierowanie": "",
        "Przekieruj do dokumentu": "",
        "Przekieruj po kliknięciu w widget": "",
        "Przekieruj przycisk więcej do": "",
        "Przekroczono dozwoloną ilość znaków: %0.": "",
        "przekroczony dozwolony rozmiar pliku (%0 MB)": "",
        "Przełącznik": "",
        "Przełożeni": "",
        "Przełożony": "",
        "Przeniesienie wybranych elementów": "",
        "przeniesiony do kosza": "",
        "Przenieś": "",
        "Przenieś${selected.length > 1 ? ' zaznaczone' : ''}": "",
        "przeniósł do kosza": "",
        "Przepisz aktualne stawki za 1000 tokenów z cennika OpenAI.": "",
        "Przepisz limit konta OpenAI.": "",
        "Przepnij alias": "",
        "Przesuń do góry": "",
        "Przesuń na dół": "",
        "Przesuń widok diagramu": "",
        "Przesuń zaznaczony element o mały krok": "",
        "Przesuń zaznaczony element o większy krok": "",
        "Przesyłanie plików powiodło się.": "",
        "Przetestuj": "",
        "Przetestuj poprawność zapisanych kluczy": "",
        "Przetestuj ustawienia poczty": "",
        "Przetestuj ustawienia Sms": "",
        "Przetłumacz moduł": "",
        "Przetłumacz słownik": "",
        "Przetwarzam Twój dokument...": "",
        "Przetwarzane": "",
        "Przetwórz z AI": "",
        "Przybliżenie diagramu": "",
        "Przybornik": "",
        "Przygotowanie kontrolek": "",
        "Przykład": "",
        "Przykład listy elementów pola typu tablica:": "",
        "Przykład odwołania do pola \"Stawka\" ze słownika Stawki VAT": "",
        "Przykład skryptu, który odnosi się do danych przekazanych przez przycisk dynamiczny": "",
        "Przykład skryptu, który pobiera dane z bazowego formularza i zwraca nowe dane dla formularza docelowego": "",
        "Przykład skryptu, który zwraca słownik z dodatkowymi danymi, które można użyć w szablonie:": "",
        "Przykład tabelki z powtarzanymi elementami:": "",
        "Przykład użycia historii w formie tabeli": "",
        "Przykład:": "",
        "Przykład: domena\\użytkownik": "",
        "Przykład: użytkownik@domena": "",
        "Przykładowa struktura danych": "",
        "Przykładowy JSON": "",
        "Przykładowy JSON:": "",
        "Przykładowy skrypt wyświetlający terminy zależne od wbranego terminu w tym samym wierszu tabeli.": "",
        "Przykładowy skrypt wyświetlający terminy, które w polu \"company\" mają nazwę spółki z pola Company1": "",
        "Przykładowy skrypt wyświetlający terminy, które w polu \"unit\" mają id działu wybranego w polu UserGroup1": "",
        "Przykładowy skrypt wyświetlający tylko terminy z zaznaczonym checkboxem \"exampleBool\", gdy użytkownik z pola User1 znajduje się w zespole o id 5": "",
        "Przykładowy skrypt wywołujący akcję systemową o nazwie \"End\"": "",
        "Przykładowy skrypt, który szuka wartości w polu oznaczonym jako tablica elementów do wyboru. Jeśli wpiszemy kilka wartości, to wszystkie muszą być znalezione w tablicy.": "",
        "Przykładowy skrypt:": "",
        "Przykłady": "",
        "Przykłady konfiguracji": "",
        "Przykłady odwołania się do pierwszego elementu w tablicy:": "",
        "Przykłady skryptów warunkowych": "",
        "Przypisanie do roli": "",
        "Przypisanie do zespołu": "",
        "Przypisanie ról": "",
        "Przypominamy, że dostęp do aukcji jest aktywny tylko po akceptacji regulaminu. Jeśli już zaakceptowałeś - możesz licytować!": "",
        "Przypomnienie": "",
        "Przypomnienie hasła": "",
        "Przyrostek": "",
        "Przywrócenie": "",
        "przywrócił z kosza": "",
        "przywrócony z kosza": "",
        "Przywróć": "",
        "Przywróć domyślną listę kolumn": "",
        "Przywróć domyślne": "",
        "Przywróć filtr": "",
        "Przywróć ustawienia domyślne reguł i celów": "",
        "Przyznaj dostęp": "",
        "public (cache przeglądarki i proxy)": "",
        "Public Id": "",
        "Publiczne": "",
        "Publikuj": "",
        "PUT: Aktualizacja wpisu": "",
        "Pytania": "",
        "Q1": "",
        "Q2": "",
        "Q3": "",
        "Q4": "",
        "Query string": "",
        "Radio": "",
        "Ranga": "",
        "Raport spójności": "",
        "Raport wierszy:": "",
        "Raport zadań": "",
        "Raporty": "",
        "Rączka – przesuwanie diagramu": "",
        "Realizuje obecnie zadanie w obiegu dokumentu": "",
        "ReCaptcha": "",
        "Regex walidujący poprawność wartości w polu (tylko dla typu String)": "",
        "Region": "",
        "Regon": "",
        "REGON": "",
        "REGON: ": "",
        "Reguła": "",
        "Reguła filtracyjna": "",
        "Reguła końcowa": "",
        "Reguła został dodana.": "",
        "reguła została usunięta.": "",
        "Reguła została zaktualizowana.": "",
        "Reguły": "",
        "Rejestr": "",
        "Rejestr w pełni elektroniczny": "",
        "Rejestr zmian": "",
        "Rejestr został dodany.": "",
        "Rejestr zostały zapisany.": "",
        "Rejestry": "",
        "reklamacje": "",
        "Relacyjne": "",
        "Repozytorium plików": "",
        "Request body": "",
        "Resetuj": "",
        "Resetuj układ": "",
        "RESTful API": "",
        "Rezygnacja": "",
        "Roczny": "",
        "Rodzaj akcji": "",
        "Rodzaj odpowiedzi": "",
        "Rodzaj źródła": "",
        "rok": "",
        "Rok": "",
        "Rola": "",
        "Rola aktywna": "",
        "Rola domyślna": "",
        "Rola skryptu": "",
        "Rola została dodana.": "",
        "Rola została usunięta.": "",
        "Rola została zaktualizowana.": "",
        "Role i uprawnienia": "",
        "Role użytkownika": "",
        "Role zespołu": "",
        "Role zostały przypisane": "",
        "Root": "",
        "Roszerzenia plików": "",
        "Roszerzenia plików rozdzielone przecinkami": "",
        "Rozdzielczość": "",
        "Rozdzielczość wygnerowanego obrazu.": "",
        "Rozgrupuj": "",
        "Rozgrupuj pola": "",
        "Rozmiar": "",
        "Rozmiar czcionki": "",
        "Rozmiar minitur": "",
        "Rozmiar okna modalnego": "",
        "Rozmiar okna popup": "",
        "Rozmiar pliku": "",
        "Rozmiar wydruku": "",
        "Rozmiar zdjęcia": "",
        "Rozmiar zdjęcia głównego": "",
        "Rozmiar zdjęcia został zmieniony.": "",
        "Rozmieść równomiernie": "",
        "Rozpoczęto tłumaczenie modułu. Może to potrwać do kilku minut.": "",
        "Rozpoznaj tekst wprowadzonego dokumentu (OCR) dla wskazanych pól modułu": "",
        "Rozszerzenia": "",
        "Rozszerzony - błedy ważne": "",
        "Rozwiń": "",
        "Równość": "",
        "SAP ID S4": "",
        "Satysfakcja": "",
        "secondary": "",
        "Sekcja": "",
        "Sentry": "",
        "Seria danych": "",
        "Serie danych": "",
        "Server Side Cache": "",
        "Serwer bazy danych": "",
        "Serwer dostępny": "",
        "Serwer plików": "",
        "Serwer został dodany.": "",
        "Serwer został usunięty.": "",
        "Serwer został zaktualizowany.": "",
        "Serwery plików": "",
        "Sesja": "",
        "Sesja nr %0": "",
        "Sesja przetwarzania nie została znaleziona lub wygasła.": "",
        "Sesja użytkownika": "",
        "Sheduler": "",
        "Sierpień": "",
        "Silnik skryptowy": "",
        "Site name": "",
        "Site URL": "",
        "Sitemap": "",
        "Skala 1-5": "",
        "Skan został dodany.": "",
        "Skopiowano do schowka": "",
        "Skopiuj kod": "",
        "Skopiuj link": "",
        "Skrócona nazwa": "",
        "Skrypt": "",
        "Skrypt archiwalny": "",
        "Skrypt dla dynamicznego modala": "",
        "Skrypt dla szablonu dokumentu": "",
        "Skrypt dla wartości domyślnych": "",
        "Skrypt filtrujący": "",
        "Skrypt może modyfikować dane całego obiektu @Model, dzięki temu wykona się on tylko raz, a nie dla każdego dokumentu osobno": "",
        "Skrypt musi być napisany w JS i musi definiować obiekt o nazwie filter, który powinien składać się z pól o nazwach zgodnych z kluczami pól formularza i wartościami wg. których nastąpi filtrowanie.": "",
        "Skrypt po eksporcie": "",
        "Skrypt po eksporcie nie zwraca żadnych danych. Jest on wykonywany w tle po zakończeniu eksportu wszystkich dokumentów.": "",
        "Skrypt po przetworzeniu dokumentu": "",
        "Skrypt powinien kończyć się wyrażeniem zwracającym wartość logiczną (true/false)": "",
        "Skrypt powinien zwrócić obiekt składający się z klucza kolumny oraz wyrażenia zwracającego wartość logiczną, określający czy dana kolumna powinna być widoczna czy nie.": "",
        "Skrypt powinien zwrócić wartość typu bool, określającą czy dane pole powinno być widoczne czy nie.": "",
        "Skrypt pozwala na wykonywanie dowolnych akcji po stronie backendu na podstawie danych z formularza.": "",
        "Skrypt przed eksportem": "",
        "Skrypt sprawdzający, czy data w polu jest w przeszłości i czy kwota jest większa niż 1000": "",
        "Skrypt sprawdzający, czy kwota dokumentu przekroczyła 10000": "",
        "Skrypt sprawdzający, czy upłynął termin dokumentu w polu 1_Date1": "",
        "Skrypt sprawdzający, czy występuje słowo kluczowe \"ważne\" w tytule": "",
        "Skrypt systemowy można modyfikować tylko poprzez migracje": "",
        "Skrypt walidacyjny": "",
        "Skrypt współdzielony": "",
        "Skrypt zliczający sumą wartości z pola numerycznego": "",
        "Skrypt został dodany.": "",
        "Skrypt został zaktualizowany.": "",
        "Skrypt zosta� zaktualizowany.": "",
        "Skrypt zwracający string jako błąd walidacji": "",
        "Skrypty": "",
        "Skrypty integracyjne": "",
        "Skrypty współdzielone": "",
        "słowa": "",
        "Słowa wykluczone": "",
        "Słownik": "",
        "Słownik dowolny": "",
        "Słownik Logito": "",
        "Słownik systemowy": "",
        "Słownik został dodany.": "",
        "Słownik został zaktualizowany.": "",
        "Słowniki": "",
        "Słowo": "",
        "Słowo bazowe": "",
        "Słowo wykluczone": "",
        "Słowo zostało dodane.": "",
        "Słowo zostało usunięte.": "",
        "Słowo zostało zaktualizowane.": "",
        "Sobota": "",
        "Sortowanie": "",
        "Sortowanie malejąco": "",
        "Sortowanie rosnąco": "",
        "Space Tool – zwiększanie przestrzeni między elementami": "",
        "Specjalizowane": "",
        "Specyfikacja": "",
        "Sposób liczenia czasu": "",
        "Sposób prezentacji zakładek": "",
        "Sposób wykonania": "",
        "Sposób wyświetlania": "",
        "Spólka": "",
        "Spółka": "",
        "Spółka została dezaktywowana.": "",
        "Spółka została dodana.": "",
        "Spółka została zaktualizowana.": "",
        "Spółki": "",
        "Spółki użytkownika": "",
        "Sprawdzenie czy pusty": "",
        "Sprawdzenie, czy pole dokumentu ma wartość": "",
        "Sprawdzenie, czy wybrano konkretną opcję w polu wyboru": "",
        "Sprawdź czy ustawienia kontrolki są poprawne.": "",
        "Sprawdź poprawność task listy": "",
        "Stack trace": "",
        "Stała wartość": "",
        "Stan powiadomienia": "",
        "Standardowa szczegółowość": "",
        "Standardowe uprawnienia": "",
        "Stanowiska pracy": "",
        "Stanowisko": "",
        "Stanowisko pracy": "",
        "Start": "",
        "status": "",
        "Status": "",
        "Status dokumentu został zmieniony.": "",
        "Status edytowanej wersji dokumentu": "",
        "Status formularza został zmieniony.": "",
        "Status modułu": "",
        "Status webhooka": "",
        "Status został zapisany": "",
        "Statusy": "",
        "Stawka VAT": "",
        "Stopka": "",
        "Strona": "",
        "Strona %0": "",
        "Strona główna": "",
        "Strona www": "",
        "Strona została usunięta.": "",
        "Struktura organizacyjna": "",
        "Struktura zwracanego obiektu:": "",
        "Studio": "",
        "Stwierdzenie": "",
        "Styczeń": "",
        "Styl obrazu": "",
        "Styl przycisku": "",
        "success": "",
        "Sukces": "",
        "Suma": "",
        "Suma danych wejściowych i wyjściowych podana w tokenach.": "",
        "Suma tokenów": "",
        "Sygnatura": "",
        "Sygnatura skopiowana": "",
        "Symbol": "",
        "Symbol ISO waluty domyślnej": "",
        "Symbol jest wymagany": "",
        "Symbol jest zajęty": "",
        "Symbol klienta": "",
        "Symbol musi mieć co najmniej 3 znaki": "",
        "Symbol musi mieć co najmniej 5 znaków": "",
        "Symbol nie może być dłuższy niż 10 znaków": "",
        "Symbol nie może być dłuższy niż 20 znaków": "",
        "Symbol w adresie URL": "",
        "Synchronizowane z bazą AD": "",
        "Synonimy": "",
        "Synonimy zostały dodane.": "",
        "Synonimy zostały usunięte.": "",
        "Synonimy zostały zaktualizowane.": "",
        "System": "",
        "System.Członkowie grupy.System.Dział.{Nazwa działu}": "",
        "System.Data bieżaca.{operator}.Dokument.Pola dokumentu.{Nazwa pola}": "",
        "System.Data bieżąca.{operator}.Proces.Pola formularza.{Nazwa pola}": "",
        "System.Dział.{Nazwa działu}": "",
        "System.Kierownicy działu.System.Dział.{Nazwa działu}": "",
        "System.Osoba wykonująca akcję": "",
        "System.Osoba wykonująca akcję.Operator.+.(Proces.Krok.{Nazwa akcji}.Proces.Pola formularza.{Nazwa pola})": "",
        "System.Przełożony.Proces.Osoba wykonująca krok.{Nazwa akcji}": "",
        "System.Uzytkownik.{Nazwa użytkownika}": "",
        "System.Użytkownik.{Nazwa użytkownika}": "",
        "System.Użytkownik.{Użytkownik}": "",
        "System.Użytkownik.{Użytkownik}.Operator.+.System.Dział.{Nazwa działu}": "",
        "System.Zespół.{Nazwa zespołu}": "",
        "System.Zespół.{Nazwa zespołu}.System.Osoba z najmniejszą ilością zadań": "",
        "Szablon": "",
        "Szablon CSV": "",
        "Szablon HTML": "",
        "Szablon modułu": "",
        "Szablon numeracji": "",
        "Szablon powiadomienia": "",
        "Szablon Razor": "",
        "Szablon tabeli został dodany": "",
        "Szablon tabeli został usunięty": "",
        "Szablon tabeli został zaktualizowany": "",
        "Szablon word": "",
        "Szablon XML": "",
        "Szablon został dodany.": "",
        "Szablon został edytowany.": "",
        "Szablon został usunięty": "",
        "Szablon został usunięty.": "",
        "Szablon został zaktualizowany.": "",
        "Szablony": "",
        "Szablony dokumentów": "",
        "Szablony tabeli": "",
        "Szacowana kwota:": "",
        "Szafir Host": "",
        "Szafir Host dla Linux/Mac OS": "",
        "Szafir Host dla Windows": "",
        "Szafir SDK ": "",
        "Szczególy importu": "",
        "Szczegółowość obrazu": "",
        "Szczegółowy - błedy krytyczne": "",
        "Szczegóły": "",
        "Szczegóły akcji systemowej": "",
        "Szczegóły asystenta": "",
        "Szczegóły dokumentu": "",
        "Szczegóły elementu": "",
        "Szczegóły formularza": "",
        "Szczegóły kontrahenta": "",
        "Szczegóły logu procesu": "",
        "Szczegóły pliku": "",
        "Szczegóły spółki": "",
        "Szczegóły terminu": "",
        "Szczegóły zadania": "",
        "Szczegóły zapytania": "",
        "Szczegóły zdarzenia": "",
        "Szczegóły zdarzenia nr %0": "",
        "Szerokość": "",
        "Szerokość (w calach)": "",
        "Szerokość dla etykiety": "",
        "Szerokość kolumn (px)": "",
        "Szerokość kolumny (px)": "",
        "Szerokość kolumny nie może być mniejsza niż %0 pikseli.": "",
        "Szerokość kolumny nie może być większa niż %0 pikseli.": "",
        "Szerokość niestandardowa etykiety": "",
        "Szkic": "",
        "Szkic można usunąć, tylko i wyłącznie wtedy gdy posiadamy chociaż 1 aktywną wersję. Czy chcesz kontynuować?": "",
        "Szukaj": "",
        "Szukaj pełnotekstowo w plikach:": "",
        "Szukaj pełnotekstowo w polach modułu:": "",
        "Szukaj ponownie": "",
        "Szukaj we wszystkich wersjach": "",
        "Szukana fraza": "",
        "Szukane słowo": "",
        "Szybkie zaznaczanie elementów": "",
        "Śnieżka": "",
        "Średni": "",
        "Średni czas dodania:": "",
        "Średnia": "",
        "Średnia artymetyczna": "",
        "Środa": "",
        "Środowisko": "",
        "Ta operacja nie jest odwracalna i spowoduje utratę danych kontrahenta.": "",
        "Ta strona jest chroniona przez reCAPTCHA i Google.": "",
        "Tabela": "",
        "Tabela VAT": "",
        "Tabele wektorowe": "",
        "Tablica elementów do wyboru, uzupełnienie tej właściwości spowoduje, że pole będzie traktowane jako select zamiast input": "",
        "Tagi": "",
        "Tak": "",
        "Tak/Nie": "",
        "Takie błędy można zwrócić w prosty sposób korzystając z serwisu IExceptionService": "",
        "Tekst": "",
        "Tekst alternatywny": "",
        "Tekst potwierdzający wymuszenie dodania dokumentu": "",
        "Tekst zastępczy": "",
        "Tel": "",
        "Tel.": "",
        "Telefon": "",
        "Telefon komórkowy": "",
        "Telefon wewnętrzny": "",
        "Ten dashboard nie zawiera jeszcze żadnych widgetów": "",
        "Ten element nie zawiera menu kontekstowego.": "",
        "Ten kanał ma możliwość wysyłania tekstu sformatowanego.": "",
        "Ten kanał nie ma możliwości wysyłania tekstu sformatowanego.": "",
        "Ten prompt pomoże AI w określeniu, czy wprowadzany dokument należy do tego modułu.": "",
        "Tenant ID": "",
        "Teraz": "",
        "Termin": "",
        "Termin cykliczny": "",
        "Termin jednorazowy": "",
        "Termin prywatny": "",
        "Termin publiczny": "",
        "Termin został dodany pomyślnie.": "",
        "Termin został dodany.": "",
        "Termin został usunięty.": "",
        "Termin został zaktualizowany.": "",
        "Terminy do słownika będzie można dodawać dopiero po zapisaniu źródła danych.": "",
        "Terminy słowników": "",
        "Test konfiguracji": "",
        "Test konfiguracji AI": "",
        "Test ustawień pomyślnie zakończony.": "",
        "Testowy adres email": "",
        "Testowy numer telefonu": "",
        "Testuj": "",
        "Testuj konfiguracje": "",
        "Testuj zapytanie": "",
        "Tłumacz": "",
        "Tłumaczenia": "",
        "Tłumaczenie słownika rozpoczęte. Ta operacja może potrwać do kilku minut.": "",
        "To pole jest wymagane": "",
        "Token": "",
        "Token został usunięty.": "",
        "Tokeny": "",
        "Tokeny dostępu": "",
        "Tokeny wejściowe": "",
        "Tokeny wyjściowe": "",
        "Tooltip": "",
        "Trace - najwięcej szczegółów": "",
        "Tracing": "",
        "Treści odpowiedzi są wymagane": "",
        "Treści pytań są wymagane": "",
        "Treść": "",
        "Treść szablonu": "",
        "Trigger": "",
        "Trwa autentykacja z SimplySign...": "",
        "Trwa generowanie obrazów": "",
        "Trwa generowanie obrazu": "",
        "Trwa generowanie opisu dla wybranego obrazu": "",
        "Trwa przekierowanie...": "",
        "Trwa przetwarzanie dokumentu, przyciski akcji będą dostępne po zakończeniu": "",
        "Tryb": "",
        "Tryb edycji": "",
        "Tryb konserwacji systemu": "",
        "Tryb pracy": "",
        "Tryb walidacji": "",
        "Tryb wysyłki": "",
        "Tryb wyświetlania": "",
        "Tryb wyświetlania formularza": "",
        "Tryb zapisu dokumentu": "",
        "Trzy kolumny": "",
        "Twoja odpowiedź została pomyślnie zapisana.": "",
        "Twoje hasło wygasło. Zmień je na nowe.": "",
        "Tworzenie dokumentów": "",
        "Twój token": "",
        "tydzień": "",
        "Tydzień": "",
        "tydzień (tygodnie) w następującym dniu": "",
        "Tygodniowy": "",
        "tylko do nowo zaproszonych": "",
        "Tylko do odczytu": "",
        "tylko dokumenty wersjonowane": "",
        "Tylko liderzy": "",
        "Tylko serwer deweloperski. Nie używać w trybie produkcyjnym. ": "",
        "Typ": "",
        "Typ agregacji": "",
        "Typ danych": "",
        "Typ dokumentu": "",
        "Typ formularza": "",
        "Typ konta": "",
        "Typ kontrahenta": "",
        "Typ licznika": "",
        "Typ listy": "",
        "Typ logiczny": "",
        "Typ logowania": "",
        "Typ mime": "",
        "Typ modułu": "",
        "Typ obiektu": "",
        "Typ odbiorcy": "",
        "Typ pliku": "",
        "Typ pola": "",
        "Typ powiadomienia": "",
        "Typ rejestru": "",
        "Typ serwera": "",
        "Typ skryptu": "",
        "Typ słownika": "",
        "Typ szablonu": "",
        "Typ właściwy": "",
        "Typ wykresu": "",
        "Typ wyszukiwania": "",
        "Typ zawartości": "",
        "Typ zmiennej": "",
        "Typ źródła": "",
        "Typ źródła danych": "",
        "typu \"%0\" o ID \"%1\"": "",
        "Typy grup": "",
        "Typy użytkowników": "",
        "Tytuł": "",
        "Tytuł formularza": "",
        "Tytuł formularza jest wymagany": "",
        "Tytuł formularza nie może być dłuższy niż %0 znaków": "",
        "Tytuł sekcji": "",
        "Uczestnicy": "",
        "uczestnika": "",
        "Udostępnianie zostało zatrzymane": "",
        "Udostępnij": "",
        "Udostępnij dla": "",
        "Udostępnij do": "",
        "Udostępnij dokument w OneDrive do": "",
        "Udostępnij w OneDrive": "",
        "Udostępnił": "",
        "Udostępnione": "",
        "udostępnionej przez Eclipse Foundation.": "",
        "Udostępniono dla": "",
        "Udostępniono dokument w OneDrive": "",
        "Układ": "",
        "Układ domyślny": "",
        "Układ listy": "",
        "Ukraiński": "",
        "Ukryj": "",
        "Ukryj etykietę": "",
        "Ukryj widok": "",
        "Ukryta": "",
        "Ukryty": "",
        "Ulica": "",
        "umowę": "",
        "umożliwiającej składanie podpisu elektronicznego.": "",
        "Upload": "",
        "Upload plików": "",
        "Upłynęła data": "",
        "Uprawnieni użytkownicy": "",
        "Uprawnienia": "",
        "Uprawnienia do dokumentów": "",
        "Uprawnienia działów": "",
        "Uprawnienia indywidualne": "",
        "Uprawnienia zespołów": "",
        "Uprawnienie indywidualne na koncie użytkownika": "",
        "Uprawnienie: ": "",
        "Uprawnione działy": "",
        "Uprawnione zespoły": "",
        "Url": "",
        "Uruchom zadanie": "",
        "Uruchom źródło danych": "",
        "Uruchomić gdy": "",
        "Uruchomienie procesu reindeksacji spowoduje czasową niedostępność danych dla użytkowników zależną od ilości dokumentów. Czy na pewno chcesz kontynuowac?": "",
        "Urządzenie zostało usunięte.": "",
        "Usługi": "",
        "Ustaw szerokości proporcjonalnie": "",
        "Ustawienia": "",
        "Ustawienia asystenta AI zostały zapisane.": "",
        "Ustawienia domyślne": "",
        "Ustawienia domyślne na filtrach": "",
        "Ustawienia domyślne na listach": "",
        "Ustawienia domyślne zostały zaktualizowane": "",
        "Ustawienia domyślne zostały zmienione": "",
        "Ustawienia grida": "",
        "Ustawienia konta": "",
        "Ustawienia modułu": "",
        "Ustawienia ogólne": "",
        "Ustawienia podstawowe": "",
        "Ustawienia powiadomień zostały zaktualizowane.": "",
        "Ustawienia sesji": "",
        "Ustawienia uprawnień zostały zapisane.": "",
        "Ustawienia widgetów zostały zapisane": "",
        "ustawienia widgetu": "",
        "Ustawienia widgetu": "",
        "Ustawienia wyszukiwania i OCR zostały zapisane.": "",
        "Ustawienia zaawansowane": "",
        "Ustawienia zostały przywrócone.": "",
        "Ustawienia zostały zapisane.": "",
        "Ustawiono dokument jako prywatny": "",
        "Ustwienia szczegółów": "",
        "usunął": "",
        "Usunął": "",
        "Usunięcie": "",
        "Usunięcie dokumentu": "",
        "Usunięcie formularzannOperacja jest nieodwracalna. Zostaną utracone wszystkie powiązane dokumenty!nnCzy na pewno chcesz usunąć wybrany formularz?": "",
        "Usunięcie indeksunnOperacja jest nieodwracalna. Czy na pewno chcesz usunąć wybrany indeks?": "",
        "Usunięcie pola spowoduje usunięcie go z konfiguracji pól wspólnych na wszystkich modułach oraz ze wszystkich wielo-modułowych list dokumentów.": "",
        "Usunięcie wybranych elementów": "",
        "Usunięte": "",
        "Usunięto z ulubionych": "",
        "usunięty": "",
        "Usunięty": "",
        "Usuń": "",
        "Usuń datę": "",
        "Usuń dział": "",
        "Usuń filtr": "",
        "Usuń grupę": "",
        "Usuń indeks": "",
        "Usuń komentarze z pliku": "",
        "Usuń kontrahenta": "",
        "Usuń obiekt": "",
        "Usuń plik": "",
        "Usuń plik z listy": "",
        "Usuń pozycję": "",
        "Usuń sekcję": "",
        "Usuń spacje": "",
        "Usuń urządzenie": "",
        "Usuń urządzenie aby odwołać zapamiętane automatyczne logowanie na swoje konto": "",
        "Usuń z ulubionych": "",
        "Usuń z zespołu": "",
        "Usuń zaznaczony element": "",
        "Usuń${selected.length > 1 ? ' zaznaczone' : ''}": "",
        "Usuwanie dokumentów": "",
        "Usuwanie użytkowników": "",
        "Usuwanie własnych dokumentów": "",
        "Usuwanie wszystkich dokumentów": "",
        "Utworzenie": "",
        "Utworzono danę wyktorową": "",
        "Utworzono kolekcję": "",
        "Utworzono powiadomienie weryfikacyjne": "",
        "Utworzony przez": "",
        "Utworzył": "",
        "Utwórz grupy": "",
        "Utwórz katalog": "",
        "Utwórz kopię formularza": "",
        "Utwórz kopię z": "",
        "Utwórz nową wersję": "",
        "Utwórz nowy": "",
        "Utwórz nowy wątek": "",
        "Uwaga": "",
        "Uwaga brak konto do przydzielenia": "",
        "Uwaga:": "",
        "UWAGA: Brak obsługi TypeScript oraz w kodzie metody nie można robić importów.": "",
        "UWAGA! Funkcja umożliwia natychmiastowe wykonanie skryptu webhook bez dodawania go do kolejki. Pomijanie kolejkowania może prowadzić do przeciążeń systemu i timeoutów, zalecane jest używanie tej opcji tylko w sytuacjach, gdy natychmiastowe wykonanie jest absolutnie konieczne.": "",
        "Uwaga! Zmiana sposobu liczenia dokumentów na miesięczny jest nieodwracalna.": "",
        "Uwagi": "",
        "Uwzględnij wydziały podrzędne": "",
        "Uzupełnij jeśli zdjęcie główne znajduje się w osobym polu": "",
        "Uzupełnij konfigurację": "",
        "Użycie historii dokumentu w szablonie": "",
        "Użycie pól dokumentu:": "",
        "Użycie w szablonie:": "",
        "Użyte narzędzie": "",
        "Użytkownicy": "",
        "Użytkownicy w tej roli": "",
        "Użytkownik": "",
        "Użytkownik \"%0\" %1 obiekt %2": "",
        "Użytkownik jest liderem zespołu": "",
        "Użytkownik nie może się zalogować dopóki konto nie jest aktywne.": "",
        "Użytkownik nie należy do żadnego zespołu.": "",
        "Użytkownik posiada pełne uprawnienia": "",
        "Użytkownik został dodany do zespołu.": "",
        "Użytkownik został dodany.": "",
        "Użytkownik został usunięty.": "",
        "Użytkownik został wylogowany.": "",
        "Użytkownik został zaktualizowany.": "",
        "Użyty Model": "",
        "VAT": "",
        "W ciele metody walidującej dostępne są poniższe zmienne:": "",
        "W każdy dzień tygodnia": "",
        "W kontekście użycia kontrolki w tabeli dynamicznej dostępna jest zmienna: \"data.TableRowIndex\", która zawiera indeks wiersza tabeli w którym znajduje się kontrolka.": "",
        "W następującym dniu:": "",
        "W obiekcie data dostępne są propki isEdit (bool, czy dokument jest w edycji) i processId": "",
        "W obrębie skryptu dostępne są następujące obiekty:": "",
        "W obrębie skryptu możliwe jest korzystanie ze wszystkich serwisów dostępnych w skryptach np. w źródłach danych": "",
        "W organizacji nie ma jeszcze żadnych działów.": "",
        "W przypadku zwracania stringa, będzie on wyświetlany jako błąd walidacji.": "",
        "W przypadku zwracania wartości boolean, true oznacza, że walidacja przeszła poprawnie, a false że wystąpił błąd.": "",
        "W przyszłości": "",
        "W skrupcie dostępny jest obiekt Model z następującymi właściwościami:": "",
        "W skrypcie dostępne są serwisy identycznie jak w skryptach uruchamianych w źródłach danych i na procesie": "",
        "W skrypcie dostępny jest obiekt \"document\", który zawiera dane dokumentu (tylko w przypadku edycji), obiekt \"rowIndex\", który w propce \"value\" zawiera index dodawanego wiersza oraz obiekt \"formId\", który w propce \"value\" zawiera id formularza:": "",
        "W skrypcie korzystać można ze wszystkich serwisów zgodnie z dokumentacją w źródłach danych.": "",
        "W skryptach procesowych dostępne są następujące obiekty:": "",
        "W skryptach procesowych dostępny jest obiekt Model z następującymi właściwościami:": "",
        "W tym trybie skrypt wywołuje się po załadowaniu formularza": "",
        "W wersji dla przeglądarek": "",
        "w wersji odpowiedniej dla używanego systemu operacyjnego, klikając na jeden z poniższych odnośników": "",
        "W zespole od %0": "",
        "W zespole od %0 do %1": "",
        "Walidacja": "",
        "Walidacja błędów obejmuje tylko najczęściej występujące przypadki. Aby sprawdzić poprawność procesu należy go przetestować.": "",
        "Walidacja certyfikatu SSL": "",
        "Walidacja danych": "",
        "Walidacja po stronie API": "",
        "Walidator": "",
        "Warn - ostrzeżenia": "",
        "warning": "",
        "Wartości": "",
        "Wartości od 0 - 1.0 (0 oznacza 0%, a 1 oznacza 100%)": "",
        "Wartości poszczególnych komórek tabeli są w formacie zgodnym z tym, co dana kontrolka zwraca na front.": "",
        "Wartość": "",
        "Wartość brutto": "",
        "Wartość domyślna": "",
        "Wartość domyślna: (&(objectClass=organizationalUnit))": "",
        "Wartość domyślna: (&(objectClass=user)": "",
        "Wartość musi być liczbą całkowitą": "",
        "Wartość musi być liczbą dodatnią": "",
        "Wartość musi być liczbą ujemną": "",
        "Wartość netto": "",
        "Wartość skopiowana do schowka.": "",
        "Warunek": "",
        "Warunek porównania do daty bieżącej pola w wybranym kroku na wskazanym formularzu": "",
        "Warunek porównania do daty bieżącej pola z dokumentu": "",
        "Warunek sprawdzający, czy kwota powiązanego zamówienia jest większa niż 1000": "",
        "Warunek sprawdzający, czy pole typu 'Tak/Nie' ma wartość Nie": "",
        "Warunek sprawdzający, czy pole typu 'Tak/Nie' ma wartość Tak": "",
        "Warunek uruchomienia zadania": "",
        "Warunek zmienne porównane do pola dokumentu": "",
        "Warunek zmienne porównane do pola w wybranym kroku na wskazanym fomrularzu": "",
        "Warunki korzystania z usług Google": "",
        "Warunki logiczne": "",
        "Warunkowe wyświetlanie kolumn tabeli": "",
        "Warunkowe wyświetlanie pól": "",
        "Warunkowo": "",
        "Ważne informacje": "",
        "Ważność": "",
        "Wątek": "",
        "Wątek główny": "",
        "Wątek główny jest kontynuowany automatycznie przez asystenta.": "",
        "Webhook": "",
        "Webhook obsługuje argument JSON i XML": "",
        "Webhook został dodany.": "",
        "Webhook został usunięty.": "",
        "Webhook został zaktualizowany.": "",
        "Webhooki": "",
        "Weekend": "",
        "Wersja": "",
        "Wersja API": "",
        "Wersja językowa": "",
        "Wersja modułu": "",
        "Wersja robocza": "",
        "Wersja utowrzona przez": "",
        "Wersje": "",
        "Wersje dokumentu": "",
        "wersji zaakceptowanej": "",
        "Wersjonowanie": "",
        "Wersjonowanie dokumentów włączone": "",
        "Wersjonowanie dokumentów wyłączone": "",
        "Wersjonowanie można zmienić tylko podczas dodawania nowego formularza.": "",
        "Wewnętrznie": "",
        "Węgierski": "",
        "Wg dat": "",
        "Wiadomość testowa została wysłana.": "",
        "Widget został dodany": "",
        "Widget został usunięty": "",
        "Widget został zapisany": "",
        "Widgety": "",
        "Widoczne w listach": "",
        "Widoczność": "",
        "Widoczność formatowania": "",
        "Widoczność kolumn": "",
        "Widoczność modułu w menu": "",
        "Widoczność sekcji w menu modułu": "",
        "Widok nieobsługiwany": "",
        "Widok ustawień": "",
        "Widzi wszystkie dokumenty w rejestrze i ich szczegóły": "",
        "Widzi wszystkie faktury w rejestrze i ich szczegóły.": "",
        "Widzi wszystkie nieobecności w rejestrze i ich szczegóły": "",
        "Widzi wszystkie pisma w rejestrze i ich szczegóły": "",
        "Widzi wszystkie reklamacje w rejestrze i ich szczegóły": "",
        "Widzi wszystkie umowy w rejestrze i ich szczegóły": "",
        "Widzi wszystkie wnioski w rejestrze i ich szczegóły": "",
        "Widżety": "",
        "Wielkość kroku": "",
        "Wielokrotny wybór": "",
        "Wiersz": "",
        "Wiersze": "",
        "Więcej": "",
        "więcej...": "",
        "Więcej...": "",
        "Wizualizacja": "",
        "Wklej komponent": "",
        "Wklej skopiowany element": "",
        "Właściwości": "",
        "Właściwości opisujące pole:": "",
        "Właściwości szablonu": "",
        "Włącz": "",
        "Włącz obsługę wprowadzania dokumentów w module biuro": "",
        "Włącz podsumowanie kolumn": "",
        "Włącz podsumowanie wierszy": "",
        "Włącz system powiadomień": "",
        "Włącz walidację po stronie API": "",
        "Włącz wsparcie AI przy wprowadzaniu dokumentów w module biuro": "",
        "Włącz wyszukiwanie pełnotekstowe w plikach": "",
        "Włączenie moderacji danych wejściowych jest zalecane.": "",
        "Włączone": "",
        "Włączony": "",
        "Województwo": "",
        "Wpis domyślny": "",
        "Wpis nadrzędny": "",
        "Wpis w sitemap": "",
        "Wpis został dodany.": "",
        "Wpis został usunięty.": "",
        "Wpis został zaakceptowany.": "",
        "Wpis został zaktualizowany.": "",
        "Wpisz kod ikony Font Awesome, aby zobaczyć podgląd": "",
        "Wpisz komentarz...": "",
        "Wpisz wiadomość": "",
        "Wprowadzamy URL do seriwsów które chemy wykluczyć. Dane mogą być odzielone przecinkiem lub być w nowej linii": "",
        "Wprowadzenie  zmian może spowodować utratę spójności jeśli dane z tego dokumentu lub dokumentów powiązanych są przeliczane w trakcie procesowania. Czy na pewno wprowadzić zmiany?": "",
        "Wprowadzona wartość jest nieprawidłowa": "",
        "Wprowadzona wartość jest za długa": "",
        "Wprowadzona wartość jest za krótka": "",
        "Wprowadzona wartość jest za niska": "",
        "Wprowadzona wartość jest za wysoka": "",
        "Wprowadzona wartość nie jest poprawna": "",
        "Wprowadź dokument z Asystentem AI": "",
        "Wprowadź prompt, który pomoże AI w klasyfikacji dokumentów do tego modułu...": "",
        "Wróć do logowania": "",
        "Wróć do strony głównej": "",
        "Wrzesień": "",
        "Wskazówka:": "",
        "Wskazuje, jak długo odpowiedź pozostaje aktualna w pamięci serwera Redis.": "",
        "Wskaż pole z argumentem": "",
        "Wstaw cztery kolumny 1/4": "",
        "Wstaw dwie kolumny 1/3 oraz 2/3": "",
        "Wstaw dwie kolumny 2/3 oraz 1/3": "",
        "Wstaw dwie równe kolumny": "",
        "Wstaw kontrolkę": "",
        "Wstaw stronę": "",
        "Wstaw szablon informacyjny ze zdjęciem": "",
        "Wstaw trzy kolumny 1/3": "",
        "Wstaw z dołu": "",
        "Wstaw z góry": "",
        "Wstaw z lewej strony": "",
        "Wstaw z prawej strony": "",
        "Wstecz": "",
        "Wstępne filtrowanie danych": "",
        "Wszyscy": "",
        "Wszyscy pracownicy mogą dodawać nieobecność.": "",
        "Wszyscy pracownicy mogą dodawać wniosek.": "",
        "Wszystkie": "",
        "Wszystkie działy": "",
        "Wszystkie niezapisane zmiany zostaną utracone.": "",
        "Wszystkie próby": "",
        "Wszystko": "",
        "Wtorek": "",
        "wybierz": "",
        "Wybierz": "",
        "wybierz długość": "",
        "Wybierz dokument": "",
        "Wybierz dokument do podglądu": "",
        "Wybierz dokumenty aby zobaczyć dostępne akcje": "",
        "Wybierz działy": "",
        "Wybierz filtr": "",
        "Wybierz formularz zawierający dodatkowe pola dla kont użytkownków": "",
        "Wybierz grupę": "",
        "Wybierz grupy użytkowników": "",
        "Wybierz katalog do którego chcesz przenieść wybrane elementy.": "",
        "wybierz model": "",
        "Wybierz moduł aby ograniczyć wiązanie do wybranego typu dokumentu": "",
        "Wybierz odpowiadające sobie procesy, aby je zaktualizować": "",
        "Wybierz plik": "",
        "Wybierz plik do udostępnienia": "",
        "Wybierz plik lub katalog": "",
        "Wybierz plik.": "",
        "Wybierz pliki": "",
        "Wybierz pliki (do {0})": "",
        "Wybierz pole": "",
        "Wybierz pole do filtrowania": "",
        "Wybierz pole dokumentu": "",
        "Wybierz pole tekstowe z dokumentu powiązanego": "",
        "Wybierz serwer": "",
        "Wybierz shortcode": "",
        "Wybierz skrypt": "",
        "Wybierz tryb kolekcje": "",
        "Wybierz tryb pracy": "",
        "Wybierz typ": "",
        "Wybierz typ odbiorcy": "",
        "Wybierz typ podpisu": "",
        "Wybierz typ powiadomienia aby zobaczyć dostępne klucze.": "",
        "Wybierz użytkownika": "",
        "Wybierz użytkowników dla których chcesz wykonać akcje": "",
        "Wybierz wątek w którym chcesz prowadzić konwersację.": "",
        "Wybierz wersję": "",
        "Wybierz zaznaczone": "",
        "Wybierz zespoły": "",
        "wybierz...": "",
        "Wybierz...": "",
        "Wybór": "",
        "Wybór języka": "",
        "Wybór wersji": "",
        "Wybór załączników": "",
        "Wybór+": "",
        "Wybrana data jest mniejsza niż dozwolona %0.": "",
        "Wybrana data jest większa niż dozwolona %0.": "",
        "Wybrana liczba jest mniejsza niż dozwolona %0.": "",
        "Wybrana liczba jest większa niż dozwolona %0.": "",
        "Wybrana spółka jest automatycznie przypisywana do importowanego dokumentu, więc mapowanie pola nie jest wymagane. Jeśli mapowanie pola jest zdefiniowane oraz wartość jest wpisana w excel, spółka zostanie nadpisana.": "",
        "Wybrane": "",
        "Wybrane %0 na %1": "",
        "Wybrane dokumenty": "",
        "Wybrane elementy zostały przeniesione.": "",
        "Wybrane elementy zostały usunięte.": "",
        "Wybrane pliki": "",
        "Wybrane pliki: {0}": "",
        "Wybrane pole zastąpi pole zgrupowane w konfiguracjach modułu": "",
        "Wybrane: %0": "",
        "Wybranie pola spowoduje, że klucz tego pola będzie wykorzystany jako klucz pola zgrupowanego.": "",
        "Wybrano %0 użytkowników.": "",
        "Wybrano dostawcę Azure AI.": "",
        "Wybrano dostawcę Azure OpenAI.": "",
        "Wybrano dostawcę OpenAI.": "",
        "Wybrano jednego użytkownika.": "",
        "Wybrany język": "",
        "Wybrany rejestr jest automatycznie przypisywany do importowanego dokumentu, więc mapowanie pola nie jest wymagane. Jeśli mapowanie pola jest zdefiniowane oraz wartość jest wpisana w excel, rejestr zostanie nadpisany.": "",
        "Wybrany użytkownik": "",
        "Wybróbuj możliwości AI": "",
        "Wyciągam dane": "",
        "Wyczyść": "",
        "Wydarzenie": "",
        "Wydarzenie cykliczne": "",
        "Wydział": "",
        "Wygenerowana odpowiedź przez model AI.": "",
        "Wygenerowane obrazy": "",
        "Wygeneruj dokumentację": "",
        "Wygeneruj metadane dla przesyłanych obrazów": "",
        "Wyklucz logowanie zależności": "",
        "Wykonaj": "",
        "Wykonawca": "",
        "Wykonywana przez skrypt robotyzujący niedostępna dla użytkownika": "",
        "Wykonywanie akcji": "",
        "Wykonywanie...": "",
        "Wykorzystaj maksymalną dostępną wysokość": "",
        "Wykorzystane": "",
        "Wykorzystanie": "",
        "Wykresy": "",
        "Wykryto zmiany w argumencie. Zapis usunie istniejący wektor w bazie. Kontynuować?": "",
        "Wyliczone daty": "",
        "Wyloguj się": "",
        "Wyloguj zalogowanego obecnie użytkownika": "",
        "Wyłaczone": "",
        "Wyłącz funkcję zbierania danych o zapoznaniu się z dokumentem": "",
        "Wyłączenie tej funkcji spowoduje, że nie będzie działo pogrubianie nieodczytanych dokumentów oraz funkcja “oko” na historii i dane potrzebne do jej działania nie będą zapisywane. Czy na pewno chcesz kontynuowac?": "",
        "Wymagaj znaków specjalnych w hasłach": "",
        "Wymagalność pola (true, false)": "",
        "wymagana jest instalacja dedykowanego rozszerzenia": "",
        "Wymagane": "",
        "Wymagane jest ustawienie minimalnej długości hasła": "",
        "Wymagane jest wybranie formularza": "",
        "Wymagane jest wybranie kategorii": "",
        "Wymagane jest wybranie komponentu": "",
        "Wymagane jest wybranie modułu": "",
        "Wymagane jest wybranie powiązania": "",
        "Wymagane jest wybranie sekcji": "",
        "Wymagane jest wybranie skryptu": "",
        "Wymagane jest wybranie trybu": "",
        "Wymagane jest wybranie źródła danych": "",
        "Wymiary": "",
        "Wymuś zmianę hasła": "",
        "Wynik testu": "",
        "Wyniki": "",
        "Wyniki testu zawszę będą ograniczone do maksymalnie 10 pozycji.": "",
        "Wypełniam formularz": "",
        "Wypełnij formularz ostatnio zapisaną wersją": "",
        "Wyrażenia do pól wyliczanych": "",
        "Wyrażenia warunkowe": "",
        "Wyrażenie (wymagane)": "",
        "Wyrażenie regularne": "",
        "Wyrażenie w postaci \"/pattern/flag\" nie jest obsługiwane, użyj same wartości pattern": "",
        "Wysłane": "",
        "Wysoka szczegółowość": "",
        "Wysokość": "",
        "Wysokość (w calach)": "",
        "Wysokość wiersza": "",
        "wystąpieniach": "",
        "Wystąpił błąd podczas aktualizacji ulubionych": "",
        "Wystąpił błąd podczas ładowania obrazu. Spróbuj ponownie.": "",
        "Wystąpił błąd podczas pobierania akcji": "",
        "Wystąpił błąd podczas pobierania danych": "",
        "Wystąpił błąd podczas pobierania konfiguracji": "",
        "Wystąpił błąd podczas pobierania konfiguracji kontrolki.": "",
        "Wystąpił błąd podczas pobierania task listy.": "",
        "Wystąpił błąd podczas pobierania ustawień.": "",
        "Wystąpił błąd podczas próby exportu użytkowników.": "",
        "Wystąpił błąd podczas próby importu definicji modułu.": "",
        "Wystąpił błąd podczas próby importu użytkowników.": "",
        "Wystąpił błąd podczas przetwarzania dokumentu": "",
        "Wystąpił błąd podczas przetwarzania dokumentu.": "",
        "Wystąpił błąd podczas usuwania dokumentu.": "",
        "Wystąpił błąd podczas usuwania rekordu": "",
        "Wystąpił błąd podczas wysyłki podpisanego dokumentu.": "",
        "Wystąpił błąd podczas zwektoryzowania": "",
        "Wystąpił błąd połączenia. Upewnij się że masz włączony internet i spróbuj ponownie.": "",
        "Wystąpił błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.": "",
        "Wystąpił problem podczas pobierania szablonu": "",
        "Wystąpił problem podczas przesyłania obrazu.": "",
        "Wystąpił problem podczas przetwarzania": "",
        "Wystąpił problem w komunikacji z Api dostawcy podpisów. Kliknij ponownie Podpisz.": "",
        "Wystąpiły błędy podczas importu procesu": "",
        "Wyst�pi� b��d podczas importu skryptu.": "",
        "Wysyłaj dane o użytkowniku": "",
        "Wysyłaj do każdego osobno": "",
        "Wysyłaj tym kanałem": "",
        "Wysyłka dokumentu": "",
        "Wyszukaj": "",
        "Wyszukaj (Ctrl+Q)": "",
        "Wyszukaj aplikacje": "",
        "Wyszukaj w działach podrzędnych": "",
        "Wyszukaj widget": "",
        "Wyszukaj wszędzie": "",
        "Wyszukaj...": "",
        "Wyszukiwanie": "",
        "Wyszukiwanie pełnotekstowe": "",
        "Wyszukiwanie plików": "",
        "Wyszukiwanie plików umożliwia asystentowi korzystanie z wiedzy z plików. Po przesłaniu pliku asystent automatycznie decyduje, kiedy pobrać treść, na podstawie żądań użytkownika.": "",
        "Wyszukiwanie w diagramie": "",
        "Wyszukiwany ciąg znaków": "",
        "Wyszukiwarka adresów ADE": "",
        "Wyszukiwarka dokumentów": "",
        "Wyślij": "",
        "Wyślij do": "",
        "Wyślij DW": "",
        "Wyślij kod": "",
        "Wyślij link": "",
        "Wyślij powiadomienie": "",
        "Wyślij wiadomość Microsoft Teams": "",
        "Wyświetl filtry": "",
        "Wyświetl wszystko": "",
        "Wyświetlaj osobny formularz dla każdego dokumentu": "",
        "Wyświetlaj tylko dokumenty których użytkownik:": "",
        "Wyświetlam": "",
        "Wyświetlamy pierwsze znalezione 10 tyś rekordów, wyników może być więcej, zawęź kryteria wyszukiwania": "",
        "Wyświetlanie dokumentów": "",
        "Wyświetlany układ / dane": "",
        "Wyświetlone zostaną 2 pierwsze znaki z wybranego pola": "",
        "Wytnij": "",
        "Wywołanie funkcji": "",
        "Wyzeruj licznik": "",
        "Wzorzec": "",
        "Wzorzec cyklu": "",
        "z": "",
        "Z uprawnieniami": "",
        "Z uprawnieniami do modułu": "",
        "Zaakceptowane": "",
        "Zaakceptowano": "",
        "Zaakceptowany": "",
        "Zaawansowane uprawnienia": "",
        "Zabierz dostęp": "",
        "Zablokowany": "",
        "Zablokuj": "",
        "Zachowaj oryginalny format obrazów": "",
        "zacznij pisać aby wyszukać użytkownika...": "",
        "Zacznij pisać Form, Entry lub Document aby uruchomić podpowiadanie.": "",
        "Zaczyna sie od": "",
        "Zadanie": "",
        "Zadanie przebudowania indeksów zostało rozpoczęte.": "",
        "Zadanie przeindeksowania danych zostało rozpoczęte.": "",
        "Zadanie zostało uruchomione.": "",
        "Zadanie zostało włączone": "",
        "Zadanie zostało wyłączone": "",
        "Zagrożenie": "",
        "Zaimportowane dane nadpiszą istniejące dane w module": "",
        "Zaimportowane dane zostaną dopisane do istniejących danych w module": "",
        "Zaimportowano definicję modułu.": "",
        "Zaimportowano listę użytkowników.": "",
        "Zaimportowano:": "",
        "Zakładka": "",
        "Zakładki": "",
        "Zakolejkowane": "",
        "Zakończ edycję": "",
        "Zakończ sesję": "",
        "Zakończ sesję aby wylogować użytkownika": "",
        "Zakończone": "",
        "Zakończono": "",
        "Zakończono import": "",
        "Zakres": "",
        "Zakres cyklu": "",
        "Zakres czasu": "",
        "Zakres dat": "",
        "Zaktualizuj formularz": "",
        "Zależna od kontrolki": "",
        "Zalogowany": "",
        "Zalogowany użytkownik": "",
        "Zaloguj do SimplySign": "",
        "Zaloguj się": "",
        "Zaloguj się na swoje konto": "",
        "Załączniki": "",
        "Zamiany zostały zapisane.": "",
        "Zamień akceptanta": "",
        "Zamknij": "",
        "Zamknij edycje": "",
        "Zamknij linię": "",
        "Zaokrąglenie": "",
        "Zapamiętaj logowanie": "",
        "Zapamiętane urządzenia": "",
        "Zapisano formularz": "",
        "Zapisuj do celu": "",
        "Zapisuję dokument w systemie...": "",
        "Zapisywanie obrazów zakończone.": "",
        "Zapisz": "",
        "Zapisz diagram": "",
        "Zapisz diagram w celu wyświetlenia błędów oraz przetestuj dokument": "",
        "Zapisz dokument jako nowy w PDF": "",
        "Zapisz filtr": "",
        "Zapisz filtry": "",
        "Zapisz i wróć": "",
        "Zapisz i zamknij": "",
        "Zapisz importowany plik do pola": "",
        "Zapisz jako": "",
        "Zapisz jako nowy filtr": "",
        "Zapisz nową wersję": "",
        "Zapisz treść OCR do pola": "",
        "Zapisz układ": "",
        "Zapisz ustawienia": "",
        "Zapisz ustawienia widgetów": "",
        "Zapisz uwagi do pola": "",
        "Zapisz widget": "",
        "Zapisz wybrane": "",
        "Zapisz wynik do pola": "",
        "Zapisz wynik we wskazanym polu": "",
        "Zapisz wynik wysyłki e-maila (powodzenie/niepowodzenie) we wskazanym polu": "",
        "Zapisz zmiany": "",
        "Zaplanowane": "",
        "Zapomniałeś hasła?": "",
        "Zapoznał się": "",
        "Zaproszenia do akceptacji": "",
        "Zaproszenia usunięte/odrzucone": "",
        "Zaproszenie zostało odrzucone": "",
        "Zaproszenie zostało zaakceptowane": "",
        "Zaproś uczestników": "",
        "Zapytanie SQL do pobrania po ID": "",
        "Zapytanie SQL do wyszukiwania": "",
        "Zarchiwizowane": "",
        "Zarządzaj filtrami": "",
        "Zarządzaj kolumnami": "",
        "Zasięg": "",
        "Zastępował": "",
        "zastępował: ": "",
        "Zastępstwa": "",
        "Zastępstwo": "",
        "Zastępstwo wygasło.": "",
        "Zastępstwo wygaśnie za 10 minut.": "",
        "Zastępstwo wygaśnie za 5 minut.": "",
        "Zastępstwo wygaśnie za minutę.": "",
        "Zastępstwo zostało dodane.": "",
        "Zastępstwo zostało usunięte.": "",
        "Zastępstwo zostało zaktualizowane.": "",
        "Zastępuje osobę": "",
        "Zastosuj zmiany w aplikacji": "",
        "Zatrzymaj": "",
        "Zatrzymaj udostępnianie": "",
        "Zatwierdź": "",
        "Zawęź filtr do dokumentów powiązanych z pola": "",
        "Zawęź listę dokumentów do dokumentów powiązanych": "",
        "Zawęż listę dokumentów na podstawie kontrahenta": "",
        "Zawiera": "",
        "Zawsze": "",
        "Zaznacz": "",
        "Zaznacz wszystkie": "",
        "Zaznacz wszystkie elementy": "",
        "Zbieracz kosztów": "",
        "Zdarzenie": "",
        "Zdjęcie": "",
        "Zdjęcie użytkownika": "",
        "Ze skryptu dynamicznego modala/przycisku możemy zwrócić błąd w taki sposób, by wyświetlił się on pod odpowiednim polem formularza nadrzędnego i w popupie.": "",
        "Zespoły": "",
        "Zespól": "",
        "Zespół": "",
        "Zespół aktywny": "",
        "Zespół został dodany.": "",
        "Zespół został usunięty.": "",
        "Zespół został zaktualizowany.": "",
        "Zgoda": "",
        "Zgrupuj pola": "",
        "Złożenie podpisu zostało zakończone sukcesem": "",
        "Zmiana akceptantów": "",
        "Zmiana elementu": "",
        "Zmiana hasła": "",
        "Zmiana prywatności": "",
        "Zmiana rozmiaru obrazu": "",
        "Zmiany ustawień monitoringu wymagają restartu aplikacji.": "",
        "Zmiany zaczną obowiązywać dopiero po przebudowaniu indeksów.": "",
        "Zmiany zostały zapisane.": "",
        "Zmiany zostaną zastosowane w aplikacji w przeciągu kikunastu sekund": "",
        "Zmieniono aktywną wersję": "",
        "Zmieniono danę wyktorową": "",
        "Zmieniono kolekcję": "",
        "Zmieniono konfigurację list": "",
        "Zmieniono nazwę wersji": "",
        "Zmieniono pola wspólne": "",
        "Zmieniono powiadomienie weryfikacyjne": "",
        "Zmieniono ustawienia widgetu": "",
        "Zmienna środowiskowa została usunięta": "",
        "Zmienna została dodana.": "",
        "Zmienna została zaktualizowana.": "",
        "Zmienna została zapisana": "",
        "zmienną": "",
        "Zmienne": "",
        "Zmienne środowiskowe": "",
        "Zmień hasło": "",
        "Zmień moduł": "",
        "Zmień nazwę": "",
        "Zmień nazwę katalogu": "",
        "Zmień nazwę pliku": "",
        "Zmień proces dla tego dokumentu": "",
        "Zmień rozmiar": "",
        "Zmień status edytowanej wersji": "",
        "Zmień wersję procesu": "",
        "Zmień widok": "",
        "Zmniejsz": "",
        "zmodyfikował": "",
        "Zmodyfikował": "",
        "zmodyfikowany": "",
        "Znajdując odpowiedni formularz...": "",
        "znaki": "",
        "Znaleziono kontrahentów o podanym NIPie.": "",
        "Zobacz sesję użytkownika": "",
        "Zobacz szczegóły sesji użytkownika": "",
        "Zobacz szczegóły zdarzenia": "",
        "Zobacz wszystkie": "",
        "Zobacz wszystkie aktualności": "",
        "Zobacz wszystkie zastępstwa": "",
        "zobaczył/a": "",
        "Został przywrócony oryginalny harmonogram": "",
        "Zresetuj hasło": "",
        "Zrestartuj aplikacje": "",
        "Zwektoryzowane": "",
        "Zwektoryzowano": "",
        "Zwektoryzuj": "",
        "Zwiń": "",
        "Zwracanie błędów ze skryptów dynamicznego modala": "",
        "Zwrócono": "",
        "Zwrócony": "",
        "Zwróć do edycji": "",
        "Zwróć do opisu": "",
        "Źródła danych": "",
        "Źródła LDAP": "",
        "Źródło": "",
        "Źródło aktywne": "",
        "Źródło błędu": "",
        "Źródło danych": "",
        "Źródło danych jest wymagane": "",
        "źródło danych zostało dodane.": "",
        "Źródło danych zostało dodane.": "",
        "Źródło danych zostało uruchomione": "",
        "Źródło danych zostało zaktualizowane.": "",
        "Źródło danych zostało zapisane.": "",
        "Źródło LDAP zostało dodane.": "",
        "Źródło LDAP zostało zaktualizowane.": "",
        "źródło zostało usunięte.": "",
        "Żaden kanał komunikacji nie został włączony w ustawieniach powiadomień.": "",
        "Żródło danych": ""
    }
};
